// Auto-generated from lib/i18n.js (mechanical split — do not hand-reorder).
// Namespace "superadmin" base dictionary. New keys for feature batches go in sibling
// fragment files, merged in ./index.js — not here.
export default {
  "fr": {
      "layout.title": "Super-Admin",
      "layout.tenantSwitcher": "Gérer un cabinet",
      "layout.chooseTenant": "— Choisir un cabinet —",
      "layout.tenantSwitcherHelp": "Accès complet aux sections",
      "layout.linkPlatform": "← Site SaaS",
      "section.platform": "Plateforme",
      "section.management": "Gestion",
      "section.hq": "Solunary HQ",
      "section.system": "Système",
      "nav.overview": "Vue d'ensemble",
      "nav.activity": "Activité",
      "nav.finance": "Finance",
      "nav.tenants": "Cabinets",
      "nav.global": "Données globales",
      "nav.globalLearn": "Learn & Vidéo (global)",
      "nav.plans": "Plans",
      "nav.catalog": "Catalogue",
      "nav.transactions": "Transactions",
      "nav.hqCustomers": "Clients",
      "nav.hqFinance": "Finance HQ",
      "nav.hqSocial": "HQ Social",
      "nav.hqGiftPromo": "Promos et cartes cadeaux",
      "nav.hqAi": "IA : analyses et agent",
      "nav.hqAutomation": "Automatisations",
      "nav.hqBlog": "Blog",
      "nav.hqSite": "Gestion du site",
      "nav.team": "Équipe",
      "nav.audit": "Audit",
      "nav.integrations": "Intégrations",
      "nav.payments": "Fournisseurs de paiement",
      "nav.platformCredentials": "Clés API plateforme",
      "nav.marketplaceFees": "Commissions marketplace",
      "nav.platformRevenue": "Revenus plateforme",
      "nav.webhooks": "Webhooks",
      "nav.settings": "Paramètres",
      "sa.nav.section.management": "Gestion",
      "sa.nav.section.finance": "Finance",
      "sa.nav.section.hq": "Plateforme HQ",
      "sa.nav.section.system": "Système",
      "sa.login.console": "Super-Admin Console",
      "sa.login.continueGoogle": "Continuer avec Google",
      "sa.login.restricted": "Accès réservé aux opérateurs autorisés de la plateforme.",
      "sa.ov.title": "Vue d'ensemble",
      "sa.ov.subtitle": "Cabinets, abonnements et revenus de toute la plateforme.",
      "sa.ov.totalTenants": "Cabinets au total",
      "sa.ov.payingTenants": "Cabinets payants",
      "sa.ov.newSignups30d": "Nouvelles inscriptions (30 jours)",
      "sa.ov.conversionRate": "Taux de conversion",
      "sa.ov.onTrial": "En essai",
      "sa.ov.churned30d": "Pertes (30 jours)",
      "sa.ov.mrrIn": "MRR ({currency})",
      "sa.ov.arrIn": "ARR projeté ({currency})",
      "sa.ov.revenue30d": "Revenus des 30 derniers jours",
      "sa.ov.revenueHint": "Net des remboursements, par jour UTC.",
      "sa.ov.noRevenue30d": "Aucun revenu sur les 30 derniers jours.",
      "sa.ov.currency": "Devise",
      "sa.ov.byPlan": "MRR par plan",
      "sa.ov.noMrr": "Aucun revenu récurrent pour l'instant.",
      "sa.ov.byStatus": "Répartition par statut",
      "sa.ov.transactions30d": "Transactions des 30 derniers jours",
      "sa.ov.txAllTime": "{n} depuis le lancement",
      "sa.ov.topTenants": "Principaux cabinets par MRR",
      "sa.ov.noTenants": "Aucun cabinet pour l'instant.",
      "sa.rev.title": "Revenus plateforme",
      "sa.rev.subtitle": "Commissions Solunary perçues sur toutes les transactions des cabinets.",
      "sa.rev.singleSource": "Source unique",
      "sa.rev.totalPlatform": "Total plateforme",
      "sa.rev.subscriptions": "Abonnements",
      "sa.rev.marketplaceCommissions": "Commissions marketplace",
      "sa.rev.entries": "lignes",
      "sa.rev.active": "actifs",
      "sa.rev.commissions": "Commissions",
      "sa.rev.volume": "Volume traité",
      "sa.rev.transactions": "Transactions",
      "sa.rev.earningTenants": "Cabinets avec revenus",
      "sa.rev.earningTenantsHint": "Praticiens avec au moins une vente, quel que soit leur statut, depuis le lancement",
      "sa.rev.topTenants": "Top cabinets par contribution",
      "sa.rev.empty": "Aucune transaction avec commission pour l'instant.",
      "sa.rev.perCurrencyHint": "Totaux et classements par devise. Les devises ne sont jamais additionnées entre elles.",
      "sa.rev.colTenant": "Cabinet",
      "sa.rev.colVolume": "Volume",
      "sa.rev.colCommission": "Commission",
      "sa.rev.colTx": "Tx",
      "sa.rev.colMargin": "Marge effective",
      "sa.rev.unattributed": "Ventes non attribuées",
      "sa.fees.error": "Erreur",
      "sa.fees.pctRange": "% entre 0 et 100",
      "sa.fees.saved": "Enregistré ✓",
      "sa.fees.title": "Commissions marketplace",
      "sa.fees.subtitle": "Définissez la commission Solunary par type de service. Appliquée automatiquement à chaque transaction. Praticien reçoit le net = montant - commission.",
      "sa.fees.formula": "Formule : commission = montant × % + frais fixe. Désactivez le service pour ne pas prélever de commission.",
      "sa.fees.svc.course": "Cours (Solunary Learn)",
      "sa.fees.svc.product": "Produits (Boutique)",
      "sa.fees.svc.telehealth": "Téléconsultations vidéo",
      "sa.fees.svc.booking": "Réservations",
      "sa.fees.svc.program": "Programmes",
      "sa.fees.svc.invoice": "Factures (Invoices)",
      "sa.fees.updated": "MAJ :",
      "sa.fees.disable": "Désactiver",
      "sa.fees.enable": "Activer",
      "sa.fees.pctLabel": "% commission",
      "sa.fees.fixedLabel": "Frais fixe (cents)",
      "sa.fees.previewLabel": "Aperçu sur 100$",
      "sa.fees.inactive": "— inactive —",
      "sa.fees.descPlaceholder": "Description interne (optionnel)",
      "sa.fees.save": "Enregistrer",
      "sa.cred.title": "Clés API plateforme",
      "sa.cred.subtitle": "Configurez les identifiants Stripe / PayPal ici plutôt que dans .env. Les secrets sont chiffrés AES-128 (Fernet) en DB.",
      "sa.cred.securityNote": "Note de sécurité : si la variable PAYMENT_ENCRYPTION_KEY n'est pas définie en environnement, une clé éphémère est générée au démarrage (dev). En production, fixez la clé Fernet dans .env pour conserver les secrets entre redémarrages.",
      "sa.cred.documentation": "Documentation →",
      "sa.cred.missing": "Manquant",
      "sa.cred.replacePlaceholder": "Remplacer la valeur actuelle…",
      "sa.cred.pastePlaceholder": "Coller la valeur",
      "sa.cred.emptyValue": "Valeur vide",
      "sa.cred.saved": "{key} enregistré ✓",
      "sa.cred.confirmDelete": "Supprimer {key} ?",
      "sa.cred.deleted": "Supprimé",
      "sa.cred.error": "Erreur",
      "act.title": "Activité plateforme",
      "act.subtitle": "Événements récents de la plateforme, du plus récent au plus ancien.",
      "act.filterType": "Type d'événement",
      "act.typeAll": "Tous les types",
      "act.type.tenant": "Inscriptions de cabinets",
      "act.type.payment": "Paiements",
      "act.type.addon": "Modules complémentaires",
      "act.type.automation": "Automatisations",
      "act.loadOlder": "Charger les plus anciens",
      "act.loadingOlder": "Chargement…",
      "act.empty": "Aucune activité.",
      "act.loadFailed": "Impossible de charger l'activité.",
      "act.ev.tenant.signup": "Nouveau cabinet inscrit",
      "act.ev.addon.enabled": "Module activé : {addon}",
      "act.ev.addon.disabled": "Module désactivé : {addon}",
      "act.ev.unknown": "Événement : {type}",
      "act.d.plan": "Forfait : {plan}",
      "act.d.trigger": "Déclencheur : {trigger}",
      "tx.title": "Facturation Solunary (SaaS)",
      "tx.subtitle": "Historique des paiements SaaS ({n}).",
      "tx.colDate": "Date",
      "tx.colTenant": "Cabinet",
      "tx.colPlan": "Plan",
      "tx.colAmount": "Montant",
      "tx.colStatus": "Statut",
      "tx.colRefundRef": "Référence de remboursement",
      "wh.title": "Webhooks",
      "wh.subtitle": "Monitoring des événements Stripe reçus.",
      "wh.reload": "Recharger",
      "wh.total": "Total",
      "wh.handled": "{n} traités",
      "wh.recent": "Événements récents",
      "wh.empty": "Aucun événement reçu.",
      "glt.title": "Learn & Telehealth — Vue globale",
      "glt.subtitle": "Tous les cours et salles de tous les cabinets.",
      "glt.tabCourses": "Cours LMS",
      "glt.tabRooms": "Rooms vidéo",
      "glt.noCourses": "Aucun cours.",
      "glt.noRooms": "Aucune room.",
      "glt.free": "Gratuit",
      "glt.published": "Publié",
      "glt.draft": "Brouillon",
      "glt.viewTenant": "Voir le cabinet",
      "glt.sessionId": "Séance :",
      "plans.title": "Plans tarifaires",
      "plans.subtitle": "Modifiez les noms et prix par devise. Effet immédiat sur la landing.",
      "plans.updated": "Plan mis à jour",
      "plans.error": "Erreur",
      "plans.perMonth": "/mois",
      "plans.save": "Enregistrer",
      "plans.tagline": "Accroche",
      "plans.taglinePh": "Courte phrase d'accroche",
      "plans.order": "Ordre d'affichage",
      "plans.monthly": "Mensuel",
      "plans.monthlyHelp": "Laissez vide si ce plan n'est pas vendu dans cette devise — la clé est omise, aucune carte à 0 $ n'est affichée.",
      "plans.annual": "Annuel",
      "plans.perYear": "/an",
      "plans.annualHelp": "Laissez vide pour appliquer le tarif mensuel × 10 à la facturation.",
      "plans.priceInvalid": "Doit être un nombre ≥ 0",
      "plans.active": "Actif",
      "plans.retiredBadge": "Retiré",
      "plans.retire": "Retirer de la vente",
      "plans.reactivate": "Réactiver",
      "plans.confirmRetire": "Retirer {name} de la vente ? Il disparaît du catalogue public, de l'inscription et du changement de plan. Les abonnés existants continuent d'être facturés normalement.",
      "plans.confirmReactivate": "Réactiver {name} ? Il redevient visible et sélectionnable partout (catalogue public, inscription, changement de plan).",
      "plans.retireOk": "Plan retiré de la vente",
      "plans.reactivateOk": "Plan réactivé",
      "plans.delete": "Supprimer",
      "plans.confirmDelete": "Supprimer définitivement {name} ? Cette action est irréversible.",
      "plans.deleteOk": "Plan supprimé",
      "plans.deleteInUse": "Impossible : {tenants} cabinet(s) et {subscriptions} abonnement(s) utilisent encore ce plan. Retirez-le de la vente (Retirer) plutôt que de le supprimer.",
      "plans.create": "Nouveau plan",
      "plans.createTitle": "Créer un plan",
      "plans.createSubtitle": "Visible immédiatement si actif.",
      "plans.planId": "Identifiant",
      "plans.planIdHelp": "Minuscules, chiffres, underscores ; commence par une lettre (ex. pro_plus).",
      "plans.planIdInvalid": "Format invalide : lettres minuscules, chiffres, _ ; doit commencer par une lettre.",
      "plans.planIdTaken": "Cet identifiant est déjà utilisé.",
      "plans.name": "Nom",
      "plans.description": "Description",
      "plans.createSubmit": "Créer le plan",
      "plans.createOk": "Plan créé",
      "plans.orderInvalid": "Doit être un entier ≥ 0",
      "plans.priceOneRequired": "Au moins une devise doit avoir un prix mensuel supérieur à 0.",
      "plans.cancel": "Annuler",
      "audit.title": "Journal d'audit",
      "audit.subtitle": "Toutes les actions super-admin sont tracées ici.",
      "audit.reload": "Recharger",
      "audit.totalEvents": "Total événements",
      "audit.phActor": "Filtre acteur (email)",
      "audit.filterAction": "Action",
      "audit.allActions": "Toutes les actions",
      "audit.filterTarget": "Type de cible",
      "audit.allTargets": "Tous les types de cible",
      "audit.practice": "Cabinet",
      "audit.actionPracticeEnter": "Entrée dans le tableau de bord d'un cabinet",
      "audit.actionPracticeWrite": "Modification dans le tableau de bord d'un cabinet",
      "audit.actionTenantDelete": "Cabinet supprimé",
      "audit.actionTenantSubscriptionsCancelled": "Abonnements du cabinet résiliés chez Stripe",
      "audit.actionTenantDeleteBlocked": "Suppression du cabinet bloquée",
      "audit.actionTenantDeleteAbandoned": "Suppression du cabinet abandonnée",
      "audit.methodPost": "Envoi",
      "audit.methodPut": "Modification",
      "audit.methodPatch": "Modification",
      "audit.methodDelete": "Suppression",
      "audit.methodGet": "Finalisation",
      "audit.writeStatus": "statut {status}",
      "audit.routeUnknown": "route inconnue",
      "audit.targetPracticeRecord": "Fiche du cabinet",
      "audit.practiceDeleted": "cabinet supprimé",
      "audit.emptyFiltered": "Aucun événement ne correspond à ces filtres.",
      "audit.clearFilters": "Effacer les filtres",
      "audit.facetsFailed": "Impossible de charger les valeurs des filtres. Utilisez Recharger pour réessayer.",
      "audit.apply": "Appliquer",
      "audit.by": "Par",
      "audit.role": "rôle",
      "audit.diffDetails": "Détails diff",
      "audit.empty": "Aucun événement.",
      "audit.countLine": "Événements : {n}",
      "audit.loadFailed": "Impossible de charger le journal d'audit.",
      "hqai.title": "Solunary AI",
      "hqai.subtitle": "Insights stratégiques + agent conversationnel avec accès aux données plateforme.",
      "hqai.tabInsights": "Insights",
      "hqai.tabAgent": "Agent",
      "hqai.briefingGenerated": "Briefing généré",
      "hqai.error": "Erreur",
      "hqai.generateBriefing": "Générer un nouveau briefing",
      "hqai.briefing": "Briefing",
      "hqai.noInsights": "Aucun briefing. Génère le premier !",
      "hqai.errorAgent": "Erreur agent",
      "hqai.newConversation": "+ Nouvelle conversation",
      "hqai.sessions": "Sessions",
      "hqai.emptySession": "(vide)",
      "hqai.msgs": "msgs",
      "hqai.noSessions": "Aucune session.",
      "hqai.agentPrompt": "Pose une question à l'agent. Ex : « Quels cabinets sont à risque ? »",
      "hqai.askPlaceholder": "Pose ta question...",
      "integ.title": "Intégrations",
      "integ.subtitle": "Configure les identifiants directement depuis le tableau de bord. Ils s'appliquent immédiatement, sans redémarrage.",
      "integ.fillOne": "Renseigne au moins un champ.",
      "integ.updated": "{label} mis à jour",
      "integ.envSynced": " + .env synchronisé",
      "integ.error": "Erreur",
      "integ.syncEnvTitle": "Écrire aussi dans le fichier .env du serveur",
      "integ.syncEnvDesc": "Les valeurs enregistrées restent en base et sont réappliquées à chaque démarrage, sauf une clé que le fichier .env définit déjà : au démarrage, la valeur du .env l'emporte. Cochez pour écrire aussi la valeur dans backend/.env.",
      "integ.statusLive": "En service",
      "integ.statusDemo": "Démo",
      "integ.statusNotConfigured": "Non configuré",
      "integ.current": "Actuelle :",
      "integ.keepExisting": "(garde la valeur existante)",
      "integ.newCredential": "Nouvel identifiant",
      "integ.save": "Sauvegarder",
      "integ.clear": "Retirer la valeur stockée",
      "integ.confirmClear": "Retirer {key} de la configuration stockée, et du fichier .env du serveur s'il la définit ? Le service concerné cessera aussitôt de l'utiliser, jusqu'à ce qu'une nouvelle valeur soit enregistrée.",
      "integ.cleared": "{key} retirée",
      "integ.sub.stripe": "Paiements + abonnements",
      "integ.sub.resend": "Emails transactionnels",
      "integ.sub.daily": "Salles de téléconsultation",
      "integ.sub.meta_oauth": "Facebook + Instagram",
      "integ.sub.linkedin_oauth": "Posts professionnels",
      "integ.sub.anthropic": "Assistant IA et texte",
      "integ.sub.gemini": "Génération d'images IA",
      "integ.notSet": "Non renseignée",
      "integ.hint.stripe": "sk_live_… ou sk_test_… (Stripe Dashboard → Developers → API keys)",
      "integ.hint.resend": "re_… (resend.com/api-keys)",
      "integ.hint.daily": "dashboard.daily.co → Developers → API key",
      "integ.hint.meta_oauth": "developers.facebook.com/apps → App ID + App Secret",
      "integ.hint.linkedin_oauth": "linkedin.com/developers/apps → Client ID + Client Secret",
      "integ.hint.anthropic": "sk-ant-… (console.anthropic.com → API keys)",
      "integ.hint.gemini": "aistudio.google.com → Get API key",
      "fin.title": "Finance",
      "fin.subtitle": "MRR multi-devise, top cabinets, séries temporelles.",
      "fin.daysSuffix": "j",
      "fin.mrrByCurrency": "MRR actuel par devise",
      "fin.totalRevenue": "Revenus depuis le lancement",
      "fin.completedTx": "{n} transactions complétées depuis le lancement",
      "fin.completedTxOne": "{n} transaction complétée depuis le lancement",
      "fin.revenuePerDay": "Revenus par jour",
      "fin.noTxPeriod": "Aucune transaction sur cette période.",
      "fin.signupsChurn": "Inscriptions et résiliations",
      "fin.churnDefinition": "Une résiliation est un cabinet dont l'abonnement a été annulé, ou qui a été supprimé alors qu'il était encore client, comptée le jour de son départ. Une suspension n'en est pas une, et un cabinet qui revient plus tard reste compté le jour de son départ.",
      "fin.noActivityPeriod": "Aucune activité sur cette période.",
      "fin.topTenants": "Top cabinets par MRR (actuel)",
      "fin.mrrHint": "Revenu récurrent des praticiens servis aujourd'hui. Non affecté par la période ci-dessous.",
      "fin.totalRevenueHint": "Cumul depuis le lancement, net des remboursements. Non affecté par la période ci-dessous.",
      "fin.periodTitle": "{n} derniers jours",
      "fin.periodRevenue": "Revenus de la période",
      "fin.periodTx": "{n} transactions sur la période",
      "fin.periodTxOne": "{n} transaction sur la période",
      "fin.rangeLabel": "Période",
      "fin.revenueCurrency": "Devise du graphique",
      "fin.legendSignups": "Inscriptions",
      "fin.legendChurn": "Résiliations",
      "fin.noPayingTenant": "Aucun cabinet actif payant.",
      "fin.topTenantsHint": "Classés par devise. Les montants de devises différentes ne sont jamais comparés.",
      "fin.noTopTenants": "Aucun cabinet payant pour l'instant.",
      "fin.arr": "ARR :",
      "pset.lblStripe": "Stripe (paiements + abonnements)",
      "pset.lblResend": "Resend (emails transactionnels)",
      "pset.lblAnthropic": "Claude (Anthropic) : assistant IA et texte",
      "pset.lblGemini": "Gemini (Google) : génération d'images IA",
      "pset.lblMetaOauth": "Meta OAuth (Facebook + Instagram)",
      "pset.lblLinkedinOauth": "LinkedIn OAuth",
      "pset.title": "Paramètres plateforme",
      "pset.subtitle": "Intégrations actives et configuration globale.",
      "pset.integrations": "Intégrations",
      "pset.configuredActive": "Configuré et actif.",
      "pset.demoActive": "Mode démo actif — pas de vraies transactions.",
      "pset.notConfigured": "Non configuré. Définis {keys} sous Système → Intégrations.",
      "pset.openIntegrations": "Ouvrir Intégrations",
      "pset.fromEmail": "Expéditeur : {email}",
      "pset.tenantMailDomain": "Domaine des e-mails des cabinets : {domain}",
      "pset.tenantMailDomainNone": "Aucun domaine d'envoi pour les cabinets : un cabinet sans domaine vérifié à lui ne peut pas envoyer d'e-mails tant que {keys} n'est pas défini.",
      "pset.keyPrefix": "Clé : {prefix}",
      "pset.badgeOk": "ACTIF",
      "pset.badgeDemo": "DÉMO",
      "pset.badgeOff": "INACTIF",
      "pset.systemInfo": "Plateforme — info système",
      "pset.publicUrl": "URL publique",
      "pset.defaultTenantSystem": "Cabinet par défaut (système)",
      "pset.saDomainsSystem": "Domaines super-admin (système)",
      "pset.serverManaged": "Ces valeurs viennent de la configuration du serveur. Elles ne changent que via la configuration de déploiement, suivie d'un redémarrage.",
      "pset.teamAccessNote": "Les accès individuels des opérateurs se gèrent depuis Équipe.",
      "pset.saDomainsNone": "Aucun. L'accès vient uniquement des droits Équipe et de la liste d'autorisation e-mail.",
      "pp.fillOne": "Renseigne au moins un champ.",
      "pp.savedProvider": "{label} sauvegardé",
      "pp.error": "Erreur",
      "pp.policyUpdated": "Politique de paiement mise à jour",
      "pp.connValid": "{label} : connexion valide",
      "pp.connInvalid": "{label} : {error}",
      "pp.invalid": "invalide",
      "pp.testError": "Erreur de test",
      "pp.title": "Providers de paiement",
      "pp.subtitle": "Configure Stripe et PayPal pour la plateforme Solunary.",
      "pp.allowedMethods": "Moyens de paiement autorisés",
      "pp.allowedDesc": "Bloquez globalement un moyen de paiement : les praticiens ne pourront plus l'utiliser ni le connecter.",
      "pp.methodStripe": "Stripe (abonnements)",
      "pp.methodStripeConnect": "Stripe Connect (marketplace)",
      "pp.methodPaypal": "PayPal",
      "pp.blocked": "Bloqué",
      "pp.allowed": "Autorisé",
      "pp.getKeys": "→ Récupère tes clés",
      "pp.connValidShort": "Connexion valide",
      "pp.statusConfigured": "Configuré",
      "pp.statusEnabled": "Activé",
      "pp.statusInactive": "Inactif",
      "pp.currentMasked": "(actuel masqué — laisser vide pour garder)",
      "pp.sandbox": "Sandbox",
      "pp.production": "Production",
      "pp.enabled": "Activé",
      "pp.test": "Tester",
      "pp.save": "Sauvegarder",
      "cat.skuUpdated": "SKU mis à jour",
      "cat.error": "Erreur",
      "cat.boosterUpdated": "Booster mis à jour",
      "cat.skuIdNameReq": "sku_id et nom requis",
      "cat.skuCreated": "SKU créé",
      "cat.boosterIdNameReq": "booster_id et nom requis",
      "cat.boosterCreated": "Booster créé",
      "cat.confirmDeleteSku": "Supprimer le SKU {id} ?",
      "cat.skuDeleted": "SKU supprimé",
      "cat.confirmDeleteBooster": "Supprimer le booster {id} ?",
      "cat.boosterDeleted": "Booster supprimé",
      "cat.title": "Catalogue produits",
      "cat.subtitle": "SKU à paiement unique (installation clé en main, reprise de données) et Boosters récurrents — créez, modifiez, supprimez.",
      "cat.tabSkus": "SKU à paiement unique",
      "cat.tabBoosters": "Boosters récurrents",
      "cat.newSku": "Nouveau SKU",
      "cat.phSkuId": "sku_id (ex: setup_quick)",
      "cat.phName": "Nom",
      "cat.phTagline": "Accroche (optionnel)",
      "cat.createSku": "Créer le SKU",
      "cat.save": "Enregistrer",
      "cat.newBooster": "Nouveau Booster",
      "cat.phBoosterId": "booster_id (ex: academy_pro)",
      "cat.createBooster": "Créer le booster",
      "team.loadError": "Chargement impossible",
      "team.error": "Erreur",
      "team.updated": "Mise à jour effectuée",
      "team.confirmRemove": "Retirer {email} de l'équipe ?",
      "team.memberRemoved": "Membre retiré",
      "team.title": "Équipe Solunary",
      "team.subtitle": "Gestion des employés plateforme et de leurs permissions.",
      "team.invite": "Inviter un membre",
      "team.newMember": "Nouveau membre",
      "team.phName": "Nom complet",
      "team.add": "Ajouter",
      "team.colMember": "Membre",
      "team.colRole": "Rôle",
      "team.colStatus": "Statut",
      "team.colPermissions": "Permissions",
      "team.colActions": "Actions",
      "team.permissionsCount": "{n} permissions",
      "team.perm.tenants.read": "Voir les cabinets",
      "team.perm.tenants.write": "Modifier les cabinets",
      "team.perm.tenants.delete": "Supprimer les cabinets",
      "team.perm.catalog.read": "Voir le catalogue",
      "team.perm.catalog.write": "Modifier le catalogue",
      "team.perm.finance.read": "Voir la finance",
      "team.perm.finance.write": "Modifier la finance",
      "team.perm.billing.rebate": "Accorder des remises",
      "team.perm.billing.adjust": "Ajuster la facturation",
      "team.perm.billing.refund": "Émettre des remboursements",
      "team.perm.activity.read": "Voir l'activité",
      "team.perm.audit.read": "Voir le journal d'audit",
      "team.perm.settings.read": "Voir les paramètres",
      "team.perm.settings.write": "Modifier les paramètres",
      "team.perm.team.read": "Voir l'équipe",
      "team.perm.team.write": "Gérer l'équipe",
      "team.perm.data.crm.read": "Voir les clients HQ",
      "team.perm.data.crm.write": "Modifier les clients HQ",
      "team.perm.data.bookings.read": "Voir les réservations",
      "team.perm.data.promos.read": "Voir les promotions",
      "team.perm.data.giftcards.read": "Voir les cartes-cadeaux",
      "team.perm.data.insights.read": "Voir les analyses",
      "team.perm.data.insights.write": "Générer des analyses IA et utiliser l'agent IA",
      "team.perm.data.programs.read": "Voir les programmes",
      "team.perm.data.content.read": "Voir le contenu",
      "team.perm.data.media.read": "Voir les médias",
      "team.perm.data.branding.read": "Voir l'image de marque",
      "team.perm.data.roadmap.read": "Voir la feuille de route",
      "team.itsYou": "(c'est vous)",
      "team.empty": "Aucun membre. Invite ton premier collaborateur.",
      "team.rolesPerms": "Rôles et permissions",
      "tl.confirmDelete": "Supprimer le cabinet {tid} ? Ses abonnements Solunary (forfait et options) seront résiliés immédiatement chez Stripe : aucune nouvelle facture ne sera émise. Les factures déjà impayées restent dues. Son adresse, et toutes celles qu'il a eues avant, ne pourront plus jamais être utilisées. Action irréversible.",
      "tl.opOk": "Opération réussie",
      "tl.error": "Erreur",
      "tl.title": "Cabinets",
      "tl.countLine": "{n} cabinets sur la plateforme",
      "tl.searchPh": "Rechercher...",
      "tl.colCabinet": "Cabinet",
      "tl.colOwner": "Propriétaire",
      "tl.colPlan": "Plan",
      "tl.colStatus": "Statut",
      "tl.colActions": "Actions",
      "tl.view360": "Vue 360° complète",
      "tl.viewSite": "Voir le site",
      "tl.manageAdmin": "Gérer l'admin de ce cabinet",
      "tl.changePlan": "Changer le plan",
      "tl.suspend": "Suspendre",
      "tl.activate": "Activer",
      "tl.delete": "Supprimer",
      "tl.changePlanFor": "Changer le plan — {name}",
      "tl.currentPlan": "Plan actuel :",
      "tl.planChanged": "Plan changé : {from} → {to}",
      "tl.currentPlanBadge": "Plan actuel",
      "tl.cancel": "Annuler",
      "hc.title": "CRM Solunary",
      "hc.subtitle": "Gère les praticiens, prospects et leur cycle de vie.",
      "hc.syncTenants": "Synchroniser depuis les cabinets",
      "hc.new": "Nouveau",
      "hc.searchPh": "Rechercher email, nom...",
      "hc.colName": "Nom",
      "hc.colEmail": "Email",
      "hc.colStage": "Étape",
      "hc.colPlan": "Plan",
      "hc.colTenant": "Cabinet",
      "hc.colNps": "NPS",
      "hc.empty": "Aucun client ne correspond.",
      "hc.updated": "Mis à jour",
      "hc.error": "Erreur",
      "hc.confirmDelete": "Supprimer ce client ?",
      "hc.deleted": "Supprimé",
      "hc.stageInfos": "Étape et infos",
      "hc.phPhone": "Téléphone",
      "hc.phCompany": "Société",
      "hc.phNps": "NPS (0-10)",
      "hc.phNotes": "Notes",
      "hc.save": "Sauvegarder",
      "hc.arNone": "Rien à payer",
      "hc.arBalance": "Dû à Solunary",
      "hc.communications": "Communications",
      "hc.noComms": "Aucune communication.",
      "hc.phSubject": "Sujet",
      "hc.phContent": "Contenu",
      "hc.linkedTenant": "Cabinet lié",
      "hc.deleteClient": "Supprimer ce client",
      "hc.created": "Client créé",
      "hc.newClient": "Nouveau client",
      "hc.phName": "Nom",
      "hc.create": "Créer",
      "hc.stage.lead": "Prospect",
      "hc.stage.trial": "Essai",
      "hc.stage.active": "Actif",
      "hc.stage.at_risk": "À risque",
      "hc.stage.suspended": "Suspendu",
      "hc.stage.churned": "Perdu",
      "hc.noPermission": "Vous n'avez pas la permission de modifier les clients HQ.",
      "hc.notFound": "Ce client n'existe plus.",
      "hc.emailExists": "Un client avec cet email existe déjà.",
      "hc.openExisting": "Ouvrir le client existant",
      "hc.npsInvalid": "Le NPS doit être un entier de 0 à 10.",
      "hc.tags": "Étiquettes",
      "hc.tagsPh": "Ajouter une étiquette (Entrée ou virgule)",
      "hc.tagRemove": "Retirer l'étiquette {tag}",
      "hc.tagTooLong": "Une étiquette fait au plus {max} caractères.",
      "hc.tagTooMany": "Un client a au plus {max} étiquettes.",
      "hc.tagControl": "Une étiquette ne peut pas contenir de caractères de contrôle.",
      "hc.practice": "Cabinet",
      "hc.practiceStatus": "Statut",
      "hc.practiceSite": "Site web",
      "hc.deleteLinked": "Ce client est propriétaire d'un cabinet. Gérez ou fermez plutôt le cabinet.",
      "hc.tenantStatus.pending": "En attente",
      "hc.tenantStatus.active": "Actif",
      "hc.tenantStatus.suspended": "Suspendu",
      "hc.tenantStatus.cancelled": "Annulé",
      "hc.tenantStatus.expired": "Expiré",
      "hf.title": "Solunary Finance",
      "hf.subtitle": "P&L, créances clients (AR), dépenses internes, projections.",
      "hf.tab.pl": "P&L",
      "hf.tab.ar": "Dû à Solunary",
      "hf.tab.expenses": "Dépenses",
      "hf.tab.forecast": "Forecast",
      "hf.totalRevenue": "Revenu total",
      "hf.totalExpenses": "Dépenses total",
      "hf.net": "Net",
      "hf.revVsExp": "Revenu vs Dépenses (mensuel, {currency})",
      "hf.noHistory": "Aucune donnée historique.",
      "hf.legendRevenue": "Revenu",
      "hf.legendExpenses": "Dépenses",
      "hf.legendNet": "Net",
      "hf.bucket.current": "À jour",
      "hf.daysOverdue": "{n} j",
      "hf.bucket.1_30": "1-30j",
      "hf.bucket.31_60": "31-60j",
      "hf.bucket.61_90": "61-90j",
      "hf.bucket.90_plus": "90j+",
      "hf.arByTenant": "Créances par cabinet",
      "hf.totalDue": "Total dû :",
      "hf.colTenant": "Cabinet",
      "hf.colInvoices": "Factures",
      "hf.colMaxDelay": "Retard max",
      "hf.colAmount": "Montant",
      "hf.noOpenAr": "Aucun cabinet ne doit d'argent à Solunary.",
      "hf.arExplainer": "Factures d'abonnement Solunary impayées des cabinets, tenues à jour depuis Stripe. L'ancienneté part de l'échéance de la facture. Une facture dont l'adresse n'a jamais appartenu à un cabinet connu est listée comme cabinet inconnu.",
      "hf.arDeletedPractice": "{name} (cabinet supprimé)",
      "hf.arUnknownPractice": "{id} (cabinet inconnu)",
      "hf.arDeletedIdentity": "Adresse {address} · supprimé le {date}",
      "hf.arDeletedIdentityUndated": "Adresse {address}",
      "hf.expenses365": "Dépenses 365j",
      "hf.newExpense": "Nouvelle dépense",
      "hf.expenseSaved": "Dépense enregistrée",
      "hf.error": "Erreur",
      "hf.phAmount": "Montant",
      "hf.phVendor": "Fournisseur",
      "hf.phDescription": "Description",
      "hf.saveExpense": "Enregistrer",
      "hf.confirmDeleteExpense": "Supprimer cette dépense ?",
      "hf.deleted": "Supprimé",
      "hf.byCategory": "Par catégorie",
      "hf.noExpense": "Aucune dépense.",
      "hf.history": "Historique",
      "hf.months": "{n} mois",
      "hf.currency": "Devise",
      "hf.baseCurrentMonth": "Base mois actuel",
      "hf.avgMonthlyGrowth": "Croissance mensuelle moy.",
      "hf.projectionTitle": "Projection {n} mois ({currency})",
      "hf.forecastExcluded": "Hors projection (autres devises, 4 derniers mois) : {amounts}.",
      "hf.notEnoughHistory": "Pas assez d'historique pour projeter.",
      "hsoc.title": "Solunary Social",
      "hsoc.subtitle": "Gestion des comptes @solunary et planification des publications.",
      "hsoc.newPost": "Nouveau post",
      "hsoc.connectedAccounts": "Comptes connectés",
      "hsoc.connect": "Connecter",
      "hsoc.noAccounts": "Aucun compte connecté. Connecte ton Facebook/Instagram/LinkedIn @solunary.",
      "hsoc.confirmDisconnect": "Déconnecter ce compte ?",
      "hsoc.disconnected": "Déconnecté",
      "hsoc.publications": "Publications",
      "hsoc.noPosts": "Aucun post.",
      "hsoc.demo": "démo",
      "hsoc.confirmDeletePost": "Supprimer ce post ?",
      "hsoc.connectAccount": "Connecter un compte",
      "hsoc.accountConnected": "Compte connecté",
      "hsoc.error": "Erreur",
      "hsoc.phHandle": "@handle",
      "hsoc.phPageId": "Page ID (optionnel)",
      "hsoc.phAccessToken": "Access Token (optionnel)",
      "hsoc.platforms": "Plateformes",
      "hsoc.connectFirst": "Connecte d'abord un compte.",
      "hsoc.choosePlatform": "Choisis au moins une plateforme.",
      "hsoc.postScheduled": "Post programmé",
      "hsoc.postPublished": "Post publié (démo)",
      "hsoc.phBody": "Que veux-tu partager ?",
      "hsoc.phMediaUrl": "URL média (optionnel)",
      "hsoc.scheduleLabel": "Programmer (laisser vide pour publier maintenant)",
      "hsoc.schedule": "Programmer",
      "hsoc.publish": "Publier",
      "hauto.title": "Automatisations Solunary",
      "hauto.subtitle": "Règles déclenchées sur événements plateforme.",
      "hauto.ruleCreated": "Règle créée",
      "hauto.error": "Erreur",
      "hauto.confirmDelete": "Supprimer ?",
      "hauto.chooseTemplate": "Choisis un modèle à installer :",
      "hauto.enterNumber": "Entre le numéro (1-{n}) :",
      "hauto.templateInstalled": "Template « {name} » installé",
      "hauto.installTemplate": "Installer un modèle",
      "hauto.visualEditor": "Éditeur visuel",
      "hauto.newRule": "Nouvelle règle",
      "hauto.phRuleName": "Nom de la règle",
      "hauto.actionsHint": "Actions (cliquez pour ajouter ou retirer)",
      "hauto.create": "Créer",
      "hauto.rulesTitle": "Règles ({n})",
      "hauto.enableDisable": "Activer/Désactiver",
      "hauto.runs": "exécutions",
      "hauto.testRun": "Simulation",
      "hauto.editVisually": "Éditer visuellement",
      "hauto.noRules": "Aucune règle.",
      "hauto.recentRuns": "Exécutions récentes",
      "hauto.actions": "actions",
      "hauto.noRuns": "Aucun run.",
      "hauto.dryRun.title": "Simulation : {rule}",
      "hauto.dryRun.hint": "Évalue la règle et liste ce que chaque action ferait. Rien n'est modifié, rien n'est envoyé.",
      "hauto.dryRun.practice": "Cabinet à simuler (facultatif)",
      "hauto.dryRun.noPractice": "Aucun cabinet",
      "hauto.dryRun.searchPractice": "Rechercher un cabinet",
      "hauto.dryRun.run": "Lancer la simulation",
      "hauto.dryRun.close": "Fermer",
      "hauto.dryRun.badge": "Simulation",
      "hauto.dryRun.matched": "Les conditions de la règle sont remplies.",
      "hauto.dryRun.notMatched": "Les conditions de la règle ne sont pas remplies : aucune action ne s'exécuterait.",
      "hauto.dryRun.nothingChanged": "Simulation uniquement : aucune donnée n'a été modifiée.",
      "hauto.status.succeeded": "Réussi",
      "hauto.status.partial": "Partiel",
      "hauto.status.skipped": "Ignoré",
      "hauto.status.failed": "Échec",
      "hauto.status.running": "En cours",
      "hauto.outcome.applied": "Appliquée",
      "hauto.outcome.simulated": "Simulée",
      "hauto.outcome.skipped": "Ignorée",
      "hauto.outcome.failed": "Échec",
      "hauto.outcomeDry.applied": "Serait appliquée",
      "hauto.outcomeDry.simulated": "Serait simulée",
      "hauto.outcomeDry.skipped": "Serait ignorée",
      "hauto.outcomeDry.failed": "Échouerait",
      "hauto.legacy": "ancien",
      "hauto.showActions": "Afficher les actions",
      "hauto.hideActions": "Masquer les actions",
      "hauto.noActionResults": "Aucun détail d'action enregistré.",
      "hauto.action.send_email": "Envoyer un e-mail",
      "hauto.action.create_task": "Créer une tâche",
      "hauto.action.notify_slack": "Notifier Slack",
      "hauto.action.tag_customer": "Étiqueter le client",
      "hauto.action.update_lifecycle": "Changer l'étape du client",
      "hauto.detail.tagged": "Étiquette « {tag} » ajoutée.",
      "hauto.detail.already_tagged": "L'étiquette « {tag} » est déjà présente.",
      "hauto.detail.invalid_tag": "L'étiquette de la règle n'est pas valide.",
      "hauto.detail.stage_set": "Étape passée de « {previous_stage} » à « {stage} ».",
      "hauto.detail.already_in_stage": "Le client est déjà à l'étape « {stage} ».",
      "hauto.detail.invalid_stage": "Étape inconnue : {stage}.",
      "hauto.detail.no_customer": "Aucune fiche client correspondante.",
      "hauto.detail.task_created": "Tâche créée : {title}.",
      "hauto.detail.email_sent": "E-mail envoyé à {to}.",
      "hauto.detail.email_not_configured": "Aucune clé d'envoi configurée : rien n'a quitté le système (destinataire : {to}).",
      "hauto.detail.no_recipient": "Aucun destinataire.",
      "hauto.detail.email_failed": "L'envoi de l'e-mail à {to} a échoué.",
      "hauto.detail.slack_not_configured": "Slack n'est pas connecté : rien n'a été envoyé.",
      "hauto.detail.unknown_action": "Type d'action inconnu : {type}.",
      "hauto.detail.action_error": "L'action a rencontré une erreur.",
      "hauto.detail.customer_created": "La fiche client a été créée.",
      "hauto.detail.customer_would_be_created": "La fiche client serait créée.",
      "vwe.newRule": "Nouvelle règle visuelle",
      "vwe.saved": "Workflow sauvegardé",
      "vwe.error": "Erreur",
      "vwe.phRuleName": "Nom de la règle",
      "vwe.save": "Sauvegarder",
      "vwe.legendTrigger": "Déclencheur",
      "vwe.legendActions": "Actions",
      "vwe.dragHint": "Glissez-déposez pour réorganiser · cliquez sur « + » pour ajouter une action",
      "t360.sec.crm": "Contacts CRM",
      "t360.sec.bookings": "RDV",
      "t360.sec.promos": "Promos",
      "t360.sec.giftcards": "Cartes-cadeaux",
      "t360.sec.products": "Boutique",
      "t360.sec.programs": "Programmes",
      "t360.sec.blog": "Articles",
      "t360.sec.media": "Médias",
      "t360.sec.automation": "Automatisations",
      "t360.sec.social_posts": "Publications sociales",
      "t360.sec.ai_sessions": "Sessions IA",
      "t360.sec.insights": "Analyses IA",
      "t360.sec.invoices": "Factures",
      "t360.sec.transactions": "Transactions",
      "t360.error": "Erreur",
      "t360.back": "Retour aux cabinets",
      "t360.openDashboard": "Ouvrir le tableau de bord du cabinet",
      "t360.financialActions": "Actions financières :",
      "t360.rebate": "Remise",
      "t360.adjustPrice": "Ajuster prix",
      "t360.refund": "Rembourser",
      "t360.plan": "Plan",
      "t360.revenue30d": "Revenu 30j",
      "t360.subscription": "Abonnement",
      "t360.entitlements": "Fonctionnalités acquises",
      "t360.financialHistory": "Historique financier",
      "t360.rebatesCredits": "Remises / crédits",
      "t360.by": "par",
      "t360.refundsTitle": "Remboursements",
      "t360.reasonRequired": "La justification est obligatoire (3 caractères min).",
      "t360.titleRebate": "Accorder une remise",
      "t360.titleAdjust": "Ajuster le prix du cabinet",
      "t360.titleRefund": "Rembourser une transaction",
      "t360.amount": "Montant",
      "t360.amountRefundHint": "(vide = remboursement total)",
      "t360.justification": "Justification (obligatoire, sera loggée)",
      "t360.confirm": "Confirmer",
  },
  "en": {
      "layout.title": "Super-Admin",
      "layout.tenantSwitcher": "Manage a tenant",
      "layout.chooseTenant": "— Choose a tenant —",
      "layout.tenantSwitcherHelp": "Full access to sections",
      "layout.linkPlatform": "← SaaS Site",
      "section.platform": "Platform",
      "section.management": "Management",
      "section.hq": "Solunary HQ",
      "section.system": "System",
      "nav.overview": "Overview",
      "nav.activity": "Activity",
      "nav.finance": "Finance",
      "nav.tenants": "Tenants",
      "nav.global": "Global data",
      "nav.globalLearn": "Learn & Video (global)",
      "nav.plans": "Plans",
      "nav.catalog": "Catalog",
      "nav.transactions": "Transactions",
      "nav.hqCustomers": "Customers",
      "nav.hqFinance": "HQ Finance",
      "nav.hqSocial": "HQ Social",
      "nav.hqGiftPromo": "Promos & Gifts",
      "nav.hqAi": "AI Insights & Agent",
      "nav.hqAutomation": "Automations",
      "nav.hqBlog": "Blog",
      "nav.hqSite": "Site Manager",
      "nav.team": "Team",
      "nav.audit": "Audit",
      "nav.integrations": "Integrations",
      "nav.payments": "Payment providers",
      "nav.platformCredentials": "Platform API keys",
      "nav.marketplaceFees": "Marketplace fees",
      "nav.platformRevenue": "Platform revenue",
      "nav.webhooks": "Webhooks",
      "nav.settings": "Settings",
      "sa.nav.section.management": "Management",
      "sa.nav.section.finance": "Finance",
      "sa.nav.section.hq": "HQ Platform",
      "sa.nav.section.system": "System",
      "sa.login.console": "Super-Admin Console",
      "sa.login.continueGoogle": "Continue with Google",
      "sa.login.restricted": "Access is limited to authorized platform operators.",
      "sa.ov.title": "Overview",
      "sa.ov.subtitle": "Practices, subscriptions and revenue across the platform.",
      "sa.ov.totalTenants": "Total tenants",
      "sa.ov.payingTenants": "Paying tenants",
      "sa.ov.newSignups30d": "New signups (30 days)",
      "sa.ov.conversionRate": "Conversion rate",
      "sa.ov.onTrial": "On trial",
      "sa.ov.churned30d": "Churned (30 days)",
      "sa.ov.mrrIn": "MRR ({currency})",
      "sa.ov.arrIn": "ARR projection ({currency})",
      "sa.ov.revenue30d": "Revenue, last 30 days",
      "sa.ov.revenueHint": "Net of refunds, by UTC day.",
      "sa.ov.noRevenue30d": "No revenue in the last 30 days.",
      "sa.ov.currency": "Currency",
      "sa.ov.byPlan": "MRR by plan",
      "sa.ov.noMrr": "No recurring revenue yet.",
      "sa.ov.byStatus": "Breakdown by status",
      "sa.ov.transactions30d": "Transactions, last 30 days",
      "sa.ov.txAllTime": "{n} since launch",
      "sa.ov.topTenants": "Top tenants by MRR",
      "sa.ov.noTenants": "No tenants yet.",
      "sa.rev.title": "Platform revenue",
      "sa.rev.subtitle": "Solunary commissions collected on all tenant transactions.",
      "sa.rev.singleSource": "Single source",
      "sa.rev.totalPlatform": "Platform total",
      "sa.rev.subscriptions": "Subscriptions",
      "sa.rev.marketplaceCommissions": "Marketplace commissions",
      "sa.rev.entries": "entries",
      "sa.rev.active": "active",
      "sa.rev.commissions": "Commissions",
      "sa.rev.volume": "Volume processed",
      "sa.rev.transactions": "Transactions",
      "sa.rev.earningTenants": "Tenants with revenue",
      "sa.rev.earningTenantsHint": "Practices with at least one sale, any status, since launch",
      "sa.rev.topTenants": "Top tenants by contribution",
      "sa.rev.empty": "No transactions with commission yet.",
      "sa.rev.perCurrencyHint": "Totals and rankings are per currency. Different currencies are never added together.",
      "sa.rev.colTenant": "Tenant",
      "sa.rev.colVolume": "Volume",
      "sa.rev.colCommission": "Commission",
      "sa.rev.colTx": "Tx",
      "sa.rev.colMargin": "Effective margin",
      "sa.rev.unattributed": "Unattributed sales",
      "sa.fees.error": "Error",
      "sa.fees.pctRange": "% between 0 and 100",
      "sa.fees.saved": "Saved ✓",
      "sa.fees.title": "Marketplace fees",
      "sa.fees.subtitle": "Set the Solunary commission per service type. Applied automatically to every transaction. Practitioner receives net = amount - commission.",
      "sa.fees.formula": "Formula: commission = amount × % + fixed fee. Disable the service to take no commission.",
      "sa.fees.svc.course": "Courses (Solunary Learn)",
      "sa.fees.svc.product": "Products (Shop)",
      "sa.fees.svc.telehealth": "Video telehealth",
      "sa.fees.svc.booking": "Bookings",
      "sa.fees.svc.program": "Programs",
      "sa.fees.svc.invoice": "Invoices",
      "sa.fees.updated": "Updated:",
      "sa.fees.disable": "Disable",
      "sa.fees.enable": "Enable",
      "sa.fees.pctLabel": "% commission",
      "sa.fees.fixedLabel": "Fixed fee (cents)",
      "sa.fees.previewLabel": "Preview on $100",
      "sa.fees.inactive": "— inactive —",
      "sa.fees.descPlaceholder": "Internal description (optional)",
      "sa.fees.save": "Save",
      "sa.cred.title": "Platform API keys",
      "sa.cred.subtitle": "Configure Stripe / PayPal credentials here instead of in .env. Secrets are AES-128 (Fernet) encrypted in the DB.",
      "sa.cred.securityNote": "Security note: if the PAYMENT_ENCRYPTION_KEY environment variable is not set, an ephemeral key is generated at startup (dev). In production, pin the Fernet key in .env to keep secrets across restarts.",
      "sa.cred.documentation": "Documentation →",
      "sa.cred.missing": "Missing",
      "sa.cred.replacePlaceholder": "Replace current value…",
      "sa.cred.pastePlaceholder": "Paste the value",
      "sa.cred.emptyValue": "Empty value",
      "sa.cred.saved": "{key} saved ✓",
      "sa.cred.confirmDelete": "Delete {key}?",
      "sa.cred.deleted": "Deleted",
      "sa.cred.error": "Error",
      "act.title": "Platform activity",
      "act.subtitle": "Recent platform events, newest first.",
      "act.filterType": "Event type",
      "act.typeAll": "All types",
      "act.type.tenant": "Practice sign-ups",
      "act.type.payment": "Payments",
      "act.type.addon": "Add-ons",
      "act.type.automation": "Automations",
      "act.loadOlder": "Load older",
      "act.loadingOlder": "Loading…",
      "act.empty": "No activity.",
      "act.loadFailed": "The activity feed could not be loaded.",
      "act.ev.tenant.signup": "New practice signed up",
      "act.ev.addon.enabled": "Add-on enabled: {addon}",
      "act.ev.addon.disabled": "Add-on disabled: {addon}",
      "act.ev.unknown": "Event: {type}",
      "act.d.plan": "Plan: {plan}",
      "act.d.trigger": "Trigger: {trigger}",
      "tx.title": "Solunary billing (SaaS)",
      "tx.subtitle": "SaaS payment history ({n}).",
      "tx.colDate": "Date",
      "tx.colTenant": "Practice",
      "tx.colPlan": "Plan",
      "tx.colAmount": "Amount",
      "tx.colStatus": "Status",
      "tx.colRefundRef": "Refund reference",
      "wh.title": "Webhooks",
      "wh.subtitle": "Monitoring of received Stripe events.",
      "wh.reload": "Reload",
      "wh.total": "Total",
      "wh.handled": "{n} handled",
      "wh.recent": "Recent events",
      "wh.empty": "No events received.",
      "glt.title": "Learn & Telehealth — Global view",
      "glt.subtitle": "All courses and rooms across all tenants.",
      "glt.tabCourses": "LMS courses",
      "glt.tabRooms": "Video rooms",
      "glt.noCourses": "No courses.",
      "glt.noRooms": "No rooms.",
      "glt.free": "Free",
      "glt.published": "Published",
      "glt.draft": "Draft",
      "glt.viewTenant": "View tenant",
      "glt.sessionId": "Session:",
      "plans.title": "Pricing plans",
      "plans.subtitle": "Edit names and prices per currency. Immediate effect on the landing page.",
      "plans.updated": "Plan updated",
      "plans.error": "Error",
      "plans.perMonth": "/month",
      "plans.save": "Save",
      "plans.tagline": "Tagline",
      "plans.taglinePh": "Short tagline",
      "plans.order": "Display order",
      "plans.monthly": "Monthly",
      "plans.monthlyHelp": "Leave blank if this plan isn't sold in this currency — the key is omitted, no $0 card is shown.",
      "plans.annual": "Annual",
      "plans.perYear": "/year",
      "plans.annualHelp": "Leave blank to fall back to monthly × 10 at billing time.",
      "plans.priceInvalid": "Must be a number ≥ 0",
      "plans.active": "Active",
      "plans.retiredBadge": "Retired",
      "plans.retire": "Retire from sale",
      "plans.reactivate": "Reactivate",
      "plans.confirmRetire": "Retire {name} from sale? It disappears from the public pricing page, signup and change-plan. Existing subscribers keep billing normally.",
      "plans.confirmReactivate": "Reactivate {name}? It becomes visible and selectable everywhere again (public catalogue, signup, change-plan).",
      "plans.retireOk": "Plan retired from sale",
      "plans.reactivateOk": "Plan reactivated",
      "plans.delete": "Delete",
      "plans.confirmDelete": "Permanently delete {name}? This cannot be undone.",
      "plans.deleteOk": "Plan deleted",
      "plans.deleteInUse": "Can't delete: {tenants} practice(s) and {subscriptions} subscription(s) still use this plan. Retire it from sale instead of deleting it.",
      "plans.create": "New plan",
      "plans.createTitle": "Create a plan",
      "plans.createSubtitle": "Visible immediately if active.",
      "plans.planId": "Plan ID",
      "plans.planIdHelp": "Lowercase letters, digits, underscores; must start with a letter (e.g. pro_plus).",
      "plans.planIdInvalid": "Invalid format: lowercase letters, digits, _; must start with a letter.",
      "plans.planIdTaken": "This plan ID is already taken.",
      "plans.name": "Name",
      "plans.description": "Description",
      "plans.createSubmit": "Create plan",
      "plans.createOk": "Plan created",
      "plans.orderInvalid": "Must be a whole number ≥ 0",
      "plans.priceOneRequired": "At least one currency needs a monthly price above zero.",
      "plans.cancel": "Cancel",
      "audit.title": "Audit log",
      "audit.subtitle": "All super-admin actions are tracked here.",
      "audit.reload": "Reload",
      "audit.totalEvents": "Total events",
      "audit.phActor": "Filter actor (email)",
      "audit.filterAction": "Action",
      "audit.allActions": "All actions",
      "audit.filterTarget": "Target type",
      "audit.allTargets": "All target types",
      "audit.practice": "Practice",
      "audit.actionPracticeEnter": "Entered a practice dashboard",
      "audit.actionPracticeWrite": "Change in a practice dashboard",
      "audit.actionTenantDelete": "Practice deleted",
      "audit.actionTenantSubscriptionsCancelled": "Practice subscriptions cancelled at Stripe",
      "audit.actionTenantDeleteBlocked": "Practice deletion blocked",
      "audit.actionTenantDeleteAbandoned": "Practice deletion abandoned",
      "audit.methodPost": "Submitted",
      "audit.methodPut": "Updated",
      "audit.methodPatch": "Updated",
      "audit.methodDelete": "Deleted",
      "audit.methodGet": "Completed",
      "audit.writeStatus": "status {status}",
      "audit.routeUnknown": "unknown route",
      "audit.targetPracticeRecord": "Practice record",
      "audit.practiceDeleted": "deleted practice",
      "audit.emptyFiltered": "No events match these filters.",
      "audit.clearFilters": "Clear filters",
      "audit.facetsFailed": "The filter values could not be loaded. Use Reload to try again.",
      "audit.apply": "Apply",
      "audit.by": "By",
      "audit.role": "role",
      "audit.diffDetails": "Diff details",
      "audit.empty": "No events.",
      "audit.countLine": "Events: {n}",
      "audit.loadFailed": "The audit log could not be loaded.",
      "hqai.title": "Solunary AI",
      "hqai.subtitle": "Strategic insights + conversational agent with access to platform data.",
      "hqai.tabInsights": "Insights",
      "hqai.tabAgent": "Agent",
      "hqai.briefingGenerated": "Briefing generated",
      "hqai.error": "Error",
      "hqai.generateBriefing": "Generate a new briefing",
      "hqai.briefing": "Briefing",
      "hqai.noInsights": "No briefing yet. Generate the first one!",
      "hqai.errorAgent": "Agent error",
      "hqai.newConversation": "+ New conversation",
      "hqai.sessions": "Sessions",
      "hqai.emptySession": "(empty)",
      "hqai.msgs": "msgs",
      "hqai.noSessions": "No sessions.",
      "hqai.agentPrompt": "Ask the agent a question. E.g. “Which tenants are at risk?”",
      "hqai.askPlaceholder": "Ask your question...",
      "integ.title": "Integrations",
      "integ.subtitle": "Configure credentials directly from the dashboard. Immediate hot-reload.",
      "integ.fillOne": "Fill in at least one field.",
      "integ.updated": "{label} updated",
      "integ.envSynced": " + .env synced",
      "integ.error": "Error",
      "integ.syncEnvTitle": "Also write to the server's .env file",
      "integ.syncEnvDesc": "Saved values stay in the database and are reapplied at every start, except a key the .env file already sets: at start, the .env value wins. Tick to also write the value into backend/.env.",
      "integ.statusLive": "Live",
      "integ.statusDemo": "Demo",
      "integ.statusNotConfigured": "Not configured",
      "integ.current": "Current:",
      "integ.keepExisting": "(keep existing value)",
      "integ.newCredential": "New credential",
      "integ.save": "Save",
      "integ.clear": "Remove the stored value",
      "integ.confirmClear": "Remove {key} from the stored configuration, and from the server's .env file if it sets it? The service it belongs to stops using it right away, until a new value is saved.",
      "integ.cleared": "{key} removed",
      "integ.sub.stripe": "Payments + subscriptions",
      "integ.sub.resend": "Transactional emails",
      "integ.sub.daily": "Telehealth rooms",
      "integ.sub.meta_oauth": "Facebook + Instagram",
      "integ.sub.linkedin_oauth": "Professional posts",
      "integ.sub.anthropic": "AI assistant and text",
      "integ.sub.gemini": "AI image generation",
      "integ.notSet": "Not set",
      "integ.hint.stripe": "sk_live_… or sk_test_… (Stripe Dashboard → Developers → API keys)",
      "integ.hint.resend": "re_… (resend.com/api-keys)",
      "integ.hint.daily": "dashboard.daily.co → Developers → API key",
      "integ.hint.meta_oauth": "developers.facebook.com/apps → App ID + App Secret",
      "integ.hint.linkedin_oauth": "linkedin.com/developers/apps → Client ID + Client Secret",
      "integ.hint.anthropic": "sk-ant-… (console.anthropic.com → API keys)",
      "integ.hint.gemini": "aistudio.google.com → Get API key",
      "fin.title": "Finance",
      "fin.subtitle": "Multi-currency MRR, top tenants, time series.",
      "fin.daysSuffix": "d",
      "fin.mrrByCurrency": "Current MRR by currency",
      "fin.totalRevenue": "Revenue since launch",
      "fin.completedTx": "{n} completed transactions since launch",
      "fin.completedTxOne": "{n} completed transaction since launch",
      "fin.revenuePerDay": "Revenue per day",
      "fin.noTxPeriod": "No transactions in this period.",
      "fin.signupsChurn": "Signups vs Churn",
      "fin.churnDefinition": "Churn counts practices whose subscription was cancelled, or that were deleted while still customers, on the day they left. A suspension is not churn, and a practice that comes back later stays counted on the day it left.",
      "fin.noActivityPeriod": "No activity in this period.",
      "fin.topTenants": "Top tenants by MRR (current)",
      "fin.mrrHint": "Recurring revenue of the practices served today. Not affected by the period below.",
      "fin.totalRevenueHint": "All time, net of refunds. Not affected by the period below.",
      "fin.periodTitle": "Last {n} days",
      "fin.periodRevenue": "Revenue in the period",
      "fin.periodTx": "{n} transactions in the period",
      "fin.periodTxOne": "{n} transaction in the period",
      "fin.rangeLabel": "Period",
      "fin.revenueCurrency": "Chart currency",
      "fin.legendSignups": "Signups",
      "fin.legendChurn": "Churn",
      "fin.noPayingTenant": "No active paying tenant.",
      "fin.topTenantsHint": "Ranked within each currency. Amounts in different currencies are never compared.",
      "fin.noTopTenants": "No paying tenants yet.",
      "fin.arr": "ARR:",
      "pset.lblStripe": "Stripe (payments + subscriptions)",
      "pset.lblResend": "Resend (transactional emails)",
      "pset.lblAnthropic": "Claude (Anthropic): AI assistant and text",
      "pset.lblGemini": "Gemini (Google): AI image generation",
      "pset.lblMetaOauth": "Meta OAuth (Facebook + Instagram)",
      "pset.lblLinkedinOauth": "LinkedIn OAuth",
      "pset.title": "Platform settings",
      "pset.subtitle": "Active integrations and global configuration.",
      "pset.integrations": "Integrations",
      "pset.configuredActive": "Configured and active.",
      "pset.demoActive": "Demo mode active — no real transactions.",
      "pset.notConfigured": "Not configured. Set {keys} under System → Integrations.",
      "pset.openIntegrations": "Open Integrations",
      "pset.fromEmail": "Sender: {email}",
      "pset.tenantMailDomain": "Practice mail domain: {domain}",
      "pset.tenantMailDomainNone": "No practice mail domain: a practice without its own verified domain cannot send email until {keys} is set.",
      "pset.keyPrefix": "Key: {prefix}",
      "pset.badgeOk": "OK",
      "pset.badgeDemo": "DEMO",
      "pset.badgeOff": "OFF",
      "pset.systemInfo": "Platform — system info",
      "pset.publicUrl": "Public URL",
      "pset.defaultTenantSystem": "Default tenant (system)",
      "pset.saDomainsSystem": "Super-admin domains (system)",
      "pset.serverManaged": "These values come from the server's configuration. They change only through the deployment configuration, followed by a restart.",
      "pset.teamAccessNote": "Individual operators get access from Team.",
      "pset.saDomainsNone": "None. Access comes only from Team grants and the email allowlist.",
      "pp.fillOne": "Fill in at least one field.",
      "pp.savedProvider": "{label} saved",
      "pp.error": "Error",
      "pp.policyUpdated": "Payment policy updated",
      "pp.connValid": "{label}: valid connection",
      "pp.connInvalid": "{label}: {error}",
      "pp.invalid": "invalid",
      "pp.testError": "Test error",
      "pp.title": "Payment providers",
      "pp.subtitle": "Configure Stripe and PayPal for the Solunary platform.",
      "pp.allowedMethods": "Allowed payment methods",
      "pp.allowedDesc": "Globally block a payment method: practitioners will no longer be able to use or connect it.",
      "pp.methodStripe": "Stripe (subscriptions)",
      "pp.methodStripeConnect": "Stripe Connect (marketplace)",
      "pp.methodPaypal": "PayPal",
      "pp.blocked": "Blocked",
      "pp.allowed": "Allowed",
      "pp.getKeys": "→ Get your keys",
      "pp.connValidShort": "Valid connection",
      "pp.statusConfigured": "Configured",
      "pp.statusEnabled": "Enabled",
      "pp.statusInactive": "Inactive",
      "pp.currentMasked": "(current masked — leave empty to keep)",
      "pp.sandbox": "Sandbox",
      "pp.production": "Production",
      "pp.enabled": "Enabled",
      "pp.test": "Test",
      "pp.save": "Save",
      "cat.skuUpdated": "SKU updated",
      "cat.error": "Error",
      "cat.boosterUpdated": "Booster updated",
      "cat.skuIdNameReq": "sku_id and name required",
      "cat.skuCreated": "SKU created",
      "cat.boosterIdNameReq": "booster_id and name required",
      "cat.boosterCreated": "Booster created",
      "cat.confirmDeleteSku": "Delete SKU {id}?",
      "cat.skuDeleted": "SKU deleted",
      "cat.confirmDeleteBooster": "Delete booster {id}?",
      "cat.boosterDeleted": "Booster deleted",
      "cat.title": "Product catalog",
      "cat.subtitle": "One-Time SKUs (turnkey + data porting) and recurring Boosters — create, edit, delete.",
      "cat.tabSkus": "One-Time SKUs",
      "cat.tabBoosters": "Recurring Boosters",
      "cat.newSku": "New SKU",
      "cat.phSkuId": "sku_id (e.g. setup_quick)",
      "cat.phName": "Name",
      "cat.phTagline": "Tagline (optional)",
      "cat.createSku": "Create the SKU",
      "cat.save": "Save",
      "cat.newBooster": "New Booster",
      "cat.phBoosterId": "booster_id (e.g. academy_pro)",
      "cat.createBooster": "Create the booster",
      "team.loadError": "Failed to load",
      "team.error": "Error",
      "team.updated": "Update done",
      "team.confirmRemove": "Remove {email} from the team?",
      "team.memberRemoved": "Member removed",
      "team.title": "Solunary team",
      "team.subtitle": "Manage platform employees and their permissions.",
      "team.invite": "Invite a member",
      "team.newMember": "New member",
      "team.phName": "Full name",
      "team.add": "Add",
      "team.colMember": "Member",
      "team.colRole": "Role",
      "team.colStatus": "Status",
      "team.colPermissions": "Permissions",
      "team.colActions": "Actions",
      "team.permissionsCount": "{n} permissions",
      "team.perm.tenants.read": "View practices",
      "team.perm.tenants.write": "Edit practices",
      "team.perm.tenants.delete": "Delete practices",
      "team.perm.catalog.read": "View catalogue",
      "team.perm.catalog.write": "Edit catalogue",
      "team.perm.finance.read": "View finance",
      "team.perm.finance.write": "Edit finance",
      "team.perm.billing.rebate": "Grant rebates",
      "team.perm.billing.adjust": "Adjust billing",
      "team.perm.billing.refund": "Issue refunds",
      "team.perm.activity.read": "View activity",
      "team.perm.audit.read": "View audit log",
      "team.perm.settings.read": "View settings",
      "team.perm.settings.write": "Edit settings",
      "team.perm.team.read": "View team",
      "team.perm.team.write": "Manage team",
      "team.perm.data.crm.read": "View HQ customers",
      "team.perm.data.crm.write": "Edit HQ customers",
      "team.perm.data.bookings.read": "View bookings",
      "team.perm.data.promos.read": "View promotions",
      "team.perm.data.giftcards.read": "View gift cards",
      "team.perm.data.insights.read": "View insights",
      "team.perm.data.insights.write": "Generate AI insights and use the AI agent",
      "team.perm.data.programs.read": "View programs",
      "team.perm.data.content.read": "View content",
      "team.perm.data.media.read": "View media",
      "team.perm.data.branding.read": "View branding",
      "team.perm.data.roadmap.read": "View roadmap",
      "team.itsYou": "(it's you)",
      "team.empty": "No members. Invite your first collaborator.",
      "team.rolesPerms": "Roles and permissions",
      "tl.confirmDelete": "Delete practice {tid}? Its Solunary plan and add-on subscriptions will be cancelled at Stripe immediately, so no further invoice will be issued. Invoices already unpaid stay owed. Its address, and every address it held before, can never be used again. This cannot be undone.",
      "tl.opOk": "Operation successful",
      "tl.error": "Error",
      "tl.title": "Tenants",
      "tl.countLine": "{n} practices on the platform",
      "tl.searchPh": "Search...",
      "tl.colCabinet": "Practice",
      "tl.colOwner": "Owner",
      "tl.colPlan": "Plan",
      "tl.colStatus": "Status",
      "tl.colActions": "Actions",
      "tl.view360": "Full 360° view",
      "tl.viewSite": "View site",
      "tl.manageAdmin": "Manage this tenant's admin",
      "tl.changePlan": "Change plan",
      "tl.suspend": "Suspend",
      "tl.activate": "Activate",
      "tl.delete": "Delete",
      "tl.changePlanFor": "Change plan — {name}",
      "tl.currentPlan": "Current plan:",
      "tl.planChanged": "Plan changed: {from} → {to}",
      "tl.currentPlanBadge": "Current plan",
      "tl.cancel": "Cancel",
      "hc.title": "Solunary CRM",
      "hc.subtitle": "Manage practitioners, prospects and their lifecycle.",
      "hc.syncTenants": "Sync from tenants",
      "hc.new": "New",
      "hc.searchPh": "Search email, name...",
      "hc.colName": "Name",
      "hc.colEmail": "Email",
      "hc.colStage": "Stage",
      "hc.colPlan": "Plan",
      "hc.colTenant": "Practice",
      "hc.colNps": "NPS",
      "hc.empty": "No clients match.",
      "hc.updated": "Updated",
      "hc.error": "Error",
      "hc.confirmDelete": "Delete this client?",
      "hc.deleted": "Deleted",
      "hc.stageInfos": "Stage & info",
      "hc.phPhone": "Phone",
      "hc.phCompany": "Company",
      "hc.phNps": "NPS (0-10)",
      "hc.phNotes": "Notes",
      "hc.save": "Save",
      "hc.arNone": "Nothing owed",
      "hc.arBalance": "Owed to Solunary",
      "hc.communications": "Communications",
      "hc.noComms": "No communications.",
      "hc.phSubject": "Subject",
      "hc.phContent": "Content",
      "hc.linkedTenant": "Linked practice",
      "hc.deleteClient": "Delete this client",
      "hc.created": "Client created",
      "hc.newClient": "New client",
      "hc.phName": "Name",
      "hc.create": "Create",
      "hc.stage.lead": "Lead",
      "hc.stage.trial": "Trial",
      "hc.stage.active": "Active",
      "hc.stage.at_risk": "At risk",
      "hc.stage.suspended": "Suspended",
      "hc.stage.churned": "Churned",
      "hc.noPermission": "You don't have permission to change HQ customers.",
      "hc.notFound": "This client no longer exists.",
      "hc.emailExists": "A client with this email already exists.",
      "hc.openExisting": "Open the existing client",
      "hc.npsInvalid": "The NPS must be a whole number from 0 to 10.",
      "hc.tags": "Tags",
      "hc.tagsPh": "Add a tag (Enter or comma)",
      "hc.tagRemove": "Remove tag {tag}",
      "hc.tagTooLong": "A tag is at most {max} characters.",
      "hc.tagTooMany": "A client has at most {max} tags.",
      "hc.tagControl": "A tag cannot contain control characters.",
      "hc.practice": "Practice",
      "hc.practiceStatus": "Status",
      "hc.practiceSite": "Website",
      "hc.deleteLinked": "This client is the owner of a practice. Manage or close the practice instead.",
      "hc.tenantStatus.pending": "Pending",
      "hc.tenantStatus.active": "Active",
      "hc.tenantStatus.suspended": "Suspended",
      "hc.tenantStatus.cancelled": "Cancelled",
      "hc.tenantStatus.expired": "Expired",
      "hf.title": "Solunary Finance",
      "hf.subtitle": "P&L, accounts receivable (AR), internal expenses, projections.",
      "hf.tab.pl": "P&L",
      "hf.tab.ar": "Owed to Solunary",
      "hf.tab.expenses": "Expenses",
      "hf.tab.forecast": "Forecast",
      "hf.totalRevenue": "Total revenue",
      "hf.totalExpenses": "Total expenses",
      "hf.net": "Net",
      "hf.revVsExp": "Revenue vs Expenses (monthly, {currency})",
      "hf.noHistory": "No historical data.",
      "hf.legendRevenue": "Revenue",
      "hf.legendExpenses": "Expenses",
      "hf.legendNet": "Net",
      "hf.bucket.current": "Current",
      "hf.daysOverdue": "{n} d",
      "hf.bucket.1_30": "1-30d",
      "hf.bucket.31_60": "31-60d",
      "hf.bucket.61_90": "61-90d",
      "hf.bucket.90_plus": "90d+",
      "hf.arByTenant": "Receivables by tenant",
      "hf.totalDue": "Total due:",
      "hf.colTenant": "Tenant",
      "hf.colInvoices": "Invoices",
      "hf.colMaxDelay": "Max overdue",
      "hf.colAmount": "Amount",
      "hf.noOpenAr": "No practice owes Solunary anything.",
      "hf.arExplainer": "Unpaid Solunary subscription invoices of practices, kept current from Stripe. Age counts from each invoice's due date. An invoice whose address never belonged to a practice known here is listed as an unknown practice.",
      "hf.arDeletedPractice": "{name} (practice deleted)",
      "hf.arUnknownPractice": "{id} (unknown practice)",
      "hf.arDeletedIdentity": "Address {address} · deleted on {date}",
      "hf.arDeletedIdentityUndated": "Address {address}",
      "hf.expenses365": "Expenses 365d",
      "hf.newExpense": "New expense",
      "hf.expenseSaved": "Expense saved",
      "hf.error": "Error",
      "hf.phAmount": "Amount",
      "hf.phVendor": "Vendor",
      "hf.phDescription": "Description",
      "hf.saveExpense": "Save",
      "hf.confirmDeleteExpense": "Delete this expense?",
      "hf.deleted": "Deleted",
      "hf.byCategory": "By category",
      "hf.noExpense": "No expenses.",
      "hf.history": "History",
      "hf.months": "{n} months",
      "hf.currency": "Currency",
      "hf.baseCurrentMonth": "Current month base",
      "hf.avgMonthlyGrowth": "Avg. monthly growth",
      "hf.projectionTitle": "{n}-month projection ({currency})",
      "hf.forecastExcluded": "Not in the projection (other currencies, last 4 months): {amounts}.",
      "hf.notEnoughHistory": "Not enough history to project.",
      "hsoc.title": "Solunary Social",
      "hsoc.subtitle": "Manage @solunary accounts and schedule publications.",
      "hsoc.newPost": "New post",
      "hsoc.connectedAccounts": "Connected accounts",
      "hsoc.connect": "Connect",
      "hsoc.noAccounts": "No connected account. Connect your Facebook/Instagram/LinkedIn @solunary.",
      "hsoc.confirmDisconnect": "Disconnect this account?",
      "hsoc.disconnected": "Disconnected",
      "hsoc.publications": "Publications",
      "hsoc.noPosts": "No posts.",
      "hsoc.demo": "demo",
      "hsoc.confirmDeletePost": "Delete this post?",
      "hsoc.connectAccount": "Connect an account",
      "hsoc.accountConnected": "Account connected",
      "hsoc.error": "Error",
      "hsoc.phHandle": "@handle",
      "hsoc.phPageId": "Page ID (optional)",
      "hsoc.phAccessToken": "Access Token (optional)",
      "hsoc.platforms": "Platforms",
      "hsoc.connectFirst": "Connect an account first.",
      "hsoc.choosePlatform": "Choose at least one platform.",
      "hsoc.postScheduled": "Post scheduled",
      "hsoc.postPublished": "Post published (demo)",
      "hsoc.phBody": "What do you want to share?",
      "hsoc.phMediaUrl": "Media URL (optional)",
      "hsoc.scheduleLabel": "Schedule (leave empty to publish now)",
      "hsoc.schedule": "Schedule",
      "hsoc.publish": "Publish",
      "hauto.title": "Solunary Automations",
      "hauto.subtitle": "Rules triggered on platform events.",
      "hauto.ruleCreated": "Rule created",
      "hauto.error": "Error",
      "hauto.confirmDelete": "Delete?",
      "hauto.chooseTemplate": "Choose a template to install:",
      "hauto.enterNumber": "Enter the number (1-{n}):",
      "hauto.templateInstalled": "Template “{name}” installed",
      "hauto.installTemplate": "Install template",
      "hauto.visualEditor": "Visual editor",
      "hauto.newRule": "New rule",
      "hauto.phRuleName": "Rule name",
      "hauto.actionsHint": "Actions (click to add or remove)",
      "hauto.create": "Create",
      "hauto.rulesTitle": "Rules ({n})",
      "hauto.enableDisable": "Enable/Disable",
      "hauto.runs": "runs",
      "hauto.testRun": "Dry run",
      "hauto.editVisually": "Edit visually",
      "hauto.noRules": "No rules.",
      "hauto.recentRuns": "Recent runs",
      "hauto.actions": "actions",
      "hauto.noRuns": "No runs.",
      "hauto.dryRun.title": "Dry run: {rule}",
      "hauto.dryRun.hint": "Evaluates the rule and lists what each action would do. Nothing is changed and nothing is sent.",
      "hauto.dryRun.practice": "Practice to simulate against (optional)",
      "hauto.dryRun.noPractice": "No practice",
      "hauto.dryRun.searchPractice": "Search practices",
      "hauto.dryRun.run": "Run dry run",
      "hauto.dryRun.close": "Close",
      "hauto.dryRun.badge": "Dry run",
      "hauto.dryRun.matched": "The rule's conditions match.",
      "hauto.dryRun.notMatched": "The rule's conditions do not match, so no action would run.",
      "hauto.dryRun.nothingChanged": "Simulation only: no data was changed.",
      "hauto.status.succeeded": "Succeeded",
      "hauto.status.partial": "Partial",
      "hauto.status.skipped": "Skipped",
      "hauto.status.failed": "Failed",
      "hauto.status.running": "Running",
      "hauto.outcome.applied": "Applied",
      "hauto.outcome.simulated": "Simulated",
      "hauto.outcome.skipped": "Skipped",
      "hauto.outcome.failed": "Failed",
      "hauto.outcomeDry.applied": "Would apply",
      "hauto.outcomeDry.simulated": "Would simulate",
      "hauto.outcomeDry.skipped": "Would skip",
      "hauto.outcomeDry.failed": "Would fail",
      "hauto.legacy": "legacy",
      "hauto.showActions": "Show actions",
      "hauto.hideActions": "Hide actions",
      "hauto.noActionResults": "No action detail was recorded.",
      "hauto.action.send_email": "Send email",
      "hauto.action.create_task": "Create task",
      "hauto.action.notify_slack": "Notify Slack",
      "hauto.action.tag_customer": "Tag customer",
      "hauto.action.update_lifecycle": "Change customer stage",
      "hauto.detail.tagged": "Tag \"{tag}\" added.",
      "hauto.detail.already_tagged": "The tag \"{tag}\" is already present.",
      "hauto.detail.invalid_tag": "The rule's tag is not valid.",
      "hauto.detail.stage_set": "Stage changed from \"{previous_stage}\" to \"{stage}\".",
      "hauto.detail.already_in_stage": "The customer is already at stage \"{stage}\".",
      "hauto.detail.invalid_stage": "Unknown stage: {stage}.",
      "hauto.detail.no_customer": "No matching customer record.",
      "hauto.detail.task_created": "Task created: {title}.",
      "hauto.detail.email_sent": "Email sent to {to}.",
      "hauto.detail.email_not_configured": "No sending key is configured, so nothing left the system (recipient: {to}).",
      "hauto.detail.no_recipient": "No recipient.",
      "hauto.detail.email_failed": "Sending the email to {to} failed.",
      "hauto.detail.slack_not_configured": "Slack is not connected, so nothing was sent.",
      "hauto.detail.unknown_action": "Unknown action type: {type}.",
      "hauto.detail.action_error": "The action hit an error.",
      "hauto.detail.customer_created": "The customer record was created.",
      "hauto.detail.customer_would_be_created": "The customer record would be created.",
      "vwe.newRule": "New visual rule",
      "vwe.saved": "Workflow saved",
      "vwe.error": "Error",
      "vwe.phRuleName": "Rule name",
      "vwe.save": "Save",
      "vwe.legendTrigger": "Trigger",
      "vwe.legendActions": "Actions",
      "vwe.dragHint": "Drag and drop to rearrange · click “+” to add an action",
      "t360.sec.crm": "CRM contacts",
      "t360.sec.bookings": "Appointments",
      "t360.sec.promos": "Promos",
      "t360.sec.giftcards": "Gift cards",
      "t360.sec.products": "Shop",
      "t360.sec.programs": "Programs",
      "t360.sec.blog": "Articles",
      "t360.sec.media": "Media",
      "t360.sec.automation": "Automations",
      "t360.sec.social_posts": "Social posts",
      "t360.sec.ai_sessions": "AI sessions",
      "t360.sec.insights": "AI Insights",
      "t360.sec.invoices": "Invoices",
      "t360.sec.transactions": "Transactions",
      "t360.error": "Error",
      "t360.back": "Back to tenants",
      "t360.openDashboard": "Open tenant dashboard",
      "t360.financialActions": "Financial actions:",
      "t360.rebate": "Rebate",
      "t360.adjustPrice": "Adjust price",
      "t360.refund": "Refund",
      "t360.plan": "Plan",
      "t360.revenue30d": "Revenue 30d",
      "t360.subscription": "Subscription",
      "t360.entitlements": "Features owned",
      "t360.financialHistory": "Financial history",
      "t360.rebatesCredits": "Rebates / credits",
      "t360.by": "by",
      "t360.refundsTitle": "Refunds",
      "t360.reasonRequired": "Justification is required (min 3 characters).",
      "t360.titleRebate": "Issue a rebate",
      "t360.titleAdjust": "Adjust the tenant's price",
      "t360.titleRefund": "Refund a transaction",
      "t360.amount": "Amount",
      "t360.amountRefundHint": "(empty = full refund)",
      "t360.justification": "Justification (required, will be logged)",
      "t360.confirm": "Confirm",
  },
  "es": {
      "layout.title": "Super-Admin",
      "layout.tenantSwitcher": "Gestionar una consulta",
      "layout.chooseTenant": "— Elegir una consulta —",
      "layout.tenantSwitcherHelp": "Acceso completo a las secciones",
      "layout.linkPlatform": "← Sitio SaaS",
      "section.platform": "Plataforma",
      "section.management": "Gestión",
      "section.hq": "Solunary HQ",
      "section.system": "Sistema",
      "nav.overview": "Resumen",
      "nav.activity": "Actividad",
      "nav.finance": "Finanzas",
      "nav.tenants": "Consultas",
      "nav.global": "Datos globales",
      "nav.globalLearn": "Learn y Video (global)",
      "nav.plans": "Planes",
      "nav.catalog": "Catálogo",
      "nav.transactions": "Transacciones",
      "nav.hqCustomers": "Clientes",
      "nav.hqFinance": "HQ Finanzas",
      "nav.hqSocial": "HQ Social",
      "nav.hqGiftPromo": "Promos y tarjetas regalo",
      "nav.hqAi": "IA: análisis y agente",
      "nav.hqAutomation": "Automatizaciones",
      "nav.hqBlog": "Blog",
      "nav.hqSite": "Gestor de sitio",
      "nav.team": "Equipo",
      "nav.audit": "Auditoría",
      "nav.integrations": "Integraciones",
      "nav.payments": "Proveedores de pago",
      "nav.platformCredentials": "Claves API plataforma",
      "nav.marketplaceFees": "Comisiones marketplace",
      "nav.platformRevenue": "Ingresos plataforma",
      "nav.webhooks": "Webhooks",
      "nav.settings": "Ajustes",
      "sa.nav.section.management": "Gestión",
      "sa.nav.section.finance": "Finanzas",
      "sa.nav.section.hq": "Plataforma HQ",
      "sa.nav.section.system": "Sistema",
      "sa.login.console": "Consola Super-Admin",
      "sa.login.continueGoogle": "Continuar con Google",
      "sa.login.restricted": "Acceso reservado a los operadores autorizados de la plataforma.",
      "sa.ov.title": "Resumen",
      "sa.ov.subtitle": "Consultas, suscripciones e ingresos de toda la plataforma.",
      "sa.ov.totalTenants": "Consultas en total",
      "sa.ov.payingTenants": "Consultas de pago",
      "sa.ov.newSignups30d": "Altas nuevas (30 días)",
      "sa.ov.conversionRate": "Tasa de conversión",
      "sa.ov.onTrial": "En prueba",
      "sa.ov.churned30d": "Bajas (30 días)",
      "sa.ov.mrrIn": "MRR ({currency})",
      "sa.ov.arrIn": "ARR proyectado ({currency})",
      "sa.ov.revenue30d": "Ingresos de los últimos 30 días",
      "sa.ov.revenueHint": "Neto de reembolsos, por día UTC.",
      "sa.ov.noRevenue30d": "Sin ingresos en los últimos 30 días.",
      "sa.ov.currency": "Moneda",
      "sa.ov.byPlan": "MRR por plan",
      "sa.ov.noMrr": "Aún no hay ingresos recurrentes.",
      "sa.ov.byStatus": "Distribución por estado",
      "sa.ov.transactions30d": "Transacciones de los últimos 30 días",
      "sa.ov.txAllTime": "{n} desde el lanzamiento",
      "sa.ov.topTenants": "Principales consultas por MRR",
      "sa.ov.noTenants": "Aún no hay consultas.",
      "sa.rev.title": "Ingresos de plataforma",
      "sa.rev.subtitle": "Comisiones Solunary cobradas sobre todas las transacciones de las consultas.",
      "sa.rev.singleSource": "Fuente única",
      "sa.rev.totalPlatform": "Total plataforma",
      "sa.rev.subscriptions": "Suscripciones",
      "sa.rev.marketplaceCommissions": "Comisiones marketplace",
      "sa.rev.entries": "entradas",
      "sa.rev.active": "activas",
      "sa.rev.commissions": "Comisiones",
      "sa.rev.volume": "Volumen procesado",
      "sa.rev.transactions": "Transacciones",
      "sa.rev.earningTenants": "Consultas con ingresos",
      "sa.rev.earningTenantsHint": "Profesionales con al menos una venta, en cualquier estado, desde el lanzamiento",
      "sa.rev.topTenants": "Top consultas por contribución",
      "sa.rev.empty": "Sin transacciones con comisión todavía.",
      "sa.rev.perCurrencyHint": "Totales y clasificaciones por moneda. Las monedas nunca se suman entre sí.",
      "sa.rev.colTenant": "Consulta",
      "sa.rev.colVolume": "Volumen",
      "sa.rev.colCommission": "Comisión",
      "sa.rev.colTx": "Tx",
      "sa.rev.colMargin": "Margen efectivo",
      "sa.rev.unattributed": "Ventas sin atribuir",
      "sa.fees.error": "Error",
      "sa.fees.pctRange": "% entre 0 y 100",
      "sa.fees.saved": "Guardado ✓",
      "sa.fees.title": "Comisiones marketplace",
      "sa.fees.subtitle": "Define la comisión Solunary por tipo de servicio. Aplicada automáticamente a cada transacción. El profesional recibe el neto = monto - comisión.",
      "sa.fees.formula": "Fórmula: comisión = monto × % + tarifa fija. Desactiva el servicio para no cobrar comisión.",
      "sa.fees.svc.course": "Cursos (Solunary Learn)",
      "sa.fees.svc.product": "Productos (Tienda)",
      "sa.fees.svc.telehealth": "Teleconsultas de video",
      "sa.fees.svc.booking": "Reservas",
      "sa.fees.svc.program": "Programas",
      "sa.fees.svc.invoice": "Facturas (Invoices)",
      "sa.fees.updated": "Act.:",
      "sa.fees.disable": "Desactivar",
      "sa.fees.enable": "Activar",
      "sa.fees.pctLabel": "% comisión",
      "sa.fees.fixedLabel": "Tarifa fija (céntimos)",
      "sa.fees.previewLabel": "Vista previa en 100$",
      "sa.fees.inactive": "— inactivo —",
      "sa.fees.descPlaceholder": "Descripción interna (opcional)",
      "sa.fees.save": "Guardar",
      "sa.cred.title": "Claves API de la plataforma",
      "sa.cred.subtitle": "Configure las credenciales de Stripe / PayPal aquí en lugar de en .env. Los secretos se cifran con AES-128 (Fernet) en la BD.",
      "sa.cred.securityNote": "Nota de seguridad: si la variable PAYMENT_ENCRYPTION_KEY no está definida en el entorno, se genera una clave efímera al iniciar (dev). En producción, fije la clave Fernet en .env para conservar los secretos entre reinicios.",
      "sa.cred.documentation": "Documentación →",
      "sa.cred.missing": "Faltante",
      "sa.cred.replacePlaceholder": "Reemplazar el valor actual…",
      "sa.cred.pastePlaceholder": "Pegar el valor",
      "sa.cred.emptyValue": "Valor vacío",
      "sa.cred.saved": "{key} guardado ✓",
      "sa.cred.confirmDelete": "¿Eliminar {key}?",
      "sa.cred.deleted": "Eliminado",
      "sa.cred.error": "Error",
      "act.title": "Actividad de la plataforma",
      "act.subtitle": "Eventos recientes de la plataforma, del más reciente al más antiguo.",
      "act.filterType": "Tipo de evento",
      "act.typeAll": "Todos los tipos",
      "act.type.tenant": "Altas de consultas",
      "act.type.payment": "Pagos",
      "act.type.addon": "Complementos",
      "act.type.automation": "Automatizaciones",
      "act.loadOlder": "Cargar anteriores",
      "act.loadingOlder": "Cargando…",
      "act.empty": "Sin actividad.",
      "act.loadFailed": "No se pudo cargar la actividad.",
      "act.ev.tenant.signup": "Nueva consulta registrada",
      "act.ev.addon.enabled": "Complemento activado: {addon}",
      "act.ev.addon.disabled": "Complemento desactivado: {addon}",
      "act.ev.unknown": "Evento: {type}",
      "act.d.plan": "Plan: {plan}",
      "act.d.trigger": "Disparador: {trigger}",
      "tx.title": "Facturación Solunary (SaaS)",
      "tx.subtitle": "Historial de pagos SaaS ({n}).",
      "tx.colDate": "Fecha",
      "tx.colTenant": "Consulta",
      "tx.colPlan": "Plan",
      "tx.colAmount": "Importe",
      "tx.colStatus": "Estado",
      "tx.colRefundRef": "Referencia de reembolso",
      "wh.title": "Webhooks",
      "wh.subtitle": "Monitoreo de los eventos Stripe recibidos.",
      "wh.reload": "Recargar",
      "wh.total": "Total",
      "wh.handled": "{n} procesados",
      "wh.recent": "Eventos recientes",
      "wh.empty": "Ningún evento recibido.",
      "glt.title": "Learn & Telehealth — Vista global",
      "glt.subtitle": "Todos los cursos y salas de todas las consultas.",
      "glt.tabCourses": "Cursos LMS",
      "glt.tabRooms": "Salas de video",
      "glt.noCourses": "Ningún curso.",
      "glt.noRooms": "Ninguna sala.",
      "glt.free": "Gratis",
      "glt.published": "Publicado",
      "glt.draft": "Borrador",
      "glt.viewTenant": "Ver consulta",
      "glt.sessionId": "Sesión:",
      "plans.title": "Planes tarifarios",
      "plans.subtitle": "Edite los nombres y precios por moneda. Efecto inmediato en la landing.",
      "plans.updated": "Plan actualizado",
      "plans.error": "Error",
      "plans.perMonth": "/mes",
      "plans.save": "Guardar",
      "plans.tagline": "Eslogan",
      "plans.taglinePh": "Eslogan corto",
      "plans.order": "Orden de visualización",
      "plans.monthly": "Mensual",
      "plans.monthlyHelp": "Déjelo en blanco si este plan no se vende en esta moneda — la clave se omite, no se muestra ninguna tarjeta a 0.",
      "plans.annual": "Anual",
      "plans.perYear": "/año",
      "plans.annualHelp": "Déjelo en blanco para aplicar el precio mensual × 10 en la facturación.",
      "plans.priceInvalid": "Debe ser un número ≥ 0",
      "plans.active": "Activo",
      "plans.retiredBadge": "Retirado",
      "plans.retire": "Retirar de la venta",
      "plans.reactivate": "Reactivar",
      "plans.confirmRetire": "¿Retirar {name} de la venta? Desaparece de la página pública de precios, del registro y del cambio de plan. Los suscriptores existentes siguen facturándose con normalidad.",
      "plans.confirmReactivate": "¿Reactivar {name}? Vuelve a ser visible y seleccionable en todas partes (catálogo público, registro, cambio de plan).",
      "plans.retireOk": "Plan retirado de la venta",
      "plans.reactivateOk": "Plan reactivado",
      "plans.delete": "Eliminar",
      "plans.confirmDelete": "¿Eliminar {name} definitivamente? Esta acción no se puede deshacer.",
      "plans.deleteOk": "Plan eliminado",
      "plans.deleteInUse": "No se puede eliminar: {tenants} consulta(s) y {subscriptions} suscripción(es) todavía usan este plan. Retírelo de la venta en lugar de eliminarlo.",
      "plans.create": "Nuevo plan",
      "plans.createTitle": "Crear un plan",
      "plans.createSubtitle": "Visible de inmediato si está activo.",
      "plans.planId": "ID del plan",
      "plans.planIdHelp": "Minúsculas, números, guiones bajos; debe empezar con una letra (ej. pro_plus).",
      "plans.planIdInvalid": "Formato inválido: minúsculas, números, _; debe empezar con una letra.",
      "plans.planIdTaken": "Este ID de plan ya está en uso.",
      "plans.name": "Nombre",
      "plans.description": "Descripción",
      "plans.createSubmit": "Crear plan",
      "plans.createOk": "Plan creado",
      "plans.orderInvalid": "Debe ser un entero ≥ 0",
      "plans.priceOneRequired": "Al menos una moneda debe tener un precio mensual mayor que cero.",
      "plans.cancel": "Cancelar",
      "audit.title": "Registro de auditoría",
      "audit.subtitle": "Todas las acciones de super-admin se registran aquí.",
      "audit.reload": "Recargar",
      "audit.totalEvents": "Total de eventos",
      "audit.phActor": "Filtrar actor (email)",
      "audit.filterAction": "Acción",
      "audit.allActions": "Todas las acciones",
      "audit.filterTarget": "Tipo de objetivo",
      "audit.allTargets": "Todos los tipos de objetivo",
      "audit.practice": "Consulta",
      "audit.actionPracticeEnter": "Entrada en el panel de una consulta",
      "audit.actionPracticeWrite": "Cambio en el panel de una consulta",
      "audit.actionTenantDelete": "Consulta eliminada",
      "audit.actionTenantSubscriptionsCancelled": "Suscripciones de la consulta canceladas en Stripe",
      "audit.actionTenantDeleteBlocked": "Eliminación de la consulta bloqueada",
      "audit.actionTenantDeleteAbandoned": "Eliminación de la consulta abandonada",
      "audit.methodPost": "Envío",
      "audit.methodPut": "Modificación",
      "audit.methodPatch": "Modificación",
      "audit.methodDelete": "Eliminación",
      "audit.methodGet": "Finalización",
      "audit.writeStatus": "estado {status}",
      "audit.routeUnknown": "ruta desconocida",
      "audit.targetPracticeRecord": "Registro de la consulta",
      "audit.practiceDeleted": "consulta eliminada",
      "audit.emptyFiltered": "Ningún evento coincide con estos filtros.",
      "audit.clearFilters": "Borrar filtros",
      "audit.facetsFailed": "No se pudieron cargar los valores de los filtros. Use Recargar para intentarlo de nuevo.",
      "audit.apply": "Aplicar",
      "audit.by": "Por",
      "audit.role": "rol",
      "audit.diffDetails": "Detalles diff",
      "audit.empty": "Ningún evento.",
      "audit.countLine": "Eventos: {n}",
      "audit.loadFailed": "No se pudo cargar el registro de auditoría.",
      "hqai.title": "Solunary AI",
      "hqai.subtitle": "Insights estratégicos + agente conversacional con acceso a los datos de la plataforma.",
      "hqai.tabInsights": "Insights",
      "hqai.tabAgent": "Agente",
      "hqai.briefingGenerated": "Briefing generado",
      "hqai.error": "Error",
      "hqai.generateBriefing": "Generar un nuevo briefing",
      "hqai.briefing": "Briefing",
      "hqai.noInsights": "Ningún briefing. ¡Genera el primero!",
      "hqai.errorAgent": "Error del agente",
      "hqai.newConversation": "+ Nueva conversación",
      "hqai.sessions": "Sesiones",
      "hqai.emptySession": "(vacío)",
      "hqai.msgs": "msgs",
      "hqai.noSessions": "Ninguna sesión.",
      "hqai.agentPrompt": "Haz una pregunta al agente. Ej: «¿Qué consultas están en riesgo?»",
      "hqai.askPlaceholder": "Haz tu pregunta...",
      "integ.title": "Integraciones",
      "integ.subtitle": "Configura las credenciales directamente desde el panel. Se aplican al instante, sin reinicio.",
      "integ.fillOne": "Rellena al menos un campo.",
      "integ.updated": "{label} actualizado",
      "integ.envSynced": " + .env sincronizado",
      "integ.error": "Error",
      "integ.syncEnvTitle": "Escribir también en el archivo .env del servidor",
      "integ.syncEnvDesc": "Los valores guardados quedan en la base de datos y se vuelven a aplicar en cada arranque, salvo una clave que el archivo .env ya define: al arrancar, gana el valor del .env. Márcalo para escribir también el valor en backend/.env.",
      "integ.statusLive": "Activo",
      "integ.statusDemo": "Demo",
      "integ.statusNotConfigured": "No configurado",
      "integ.current": "Actual:",
      "integ.keepExisting": "(mantener el valor existente)",
      "integ.newCredential": "Nueva credencial",
      "integ.save": "Guardar",
      "integ.clear": "Eliminar el valor almacenado",
      "integ.confirmClear": "¿Eliminar {key} de la configuración almacenada, y del archivo .env del servidor si la define? El servicio correspondiente dejará de usarla de inmediato, hasta que se guarde un nuevo valor.",
      "integ.cleared": "{key} eliminada",
      "integ.sub.stripe": "Pagos + suscripciones",
      "integ.sub.resend": "Emails transaccionales",
      "integ.sub.daily": "Salas de teleconsulta",
      "integ.sub.meta_oauth": "Facebook + Instagram",
      "integ.sub.linkedin_oauth": "Publicaciones profesionales",
      "integ.sub.anthropic": "Asistente IA y texto",
      "integ.sub.gemini": "Generación de imágenes IA",
      "integ.notSet": "Sin configurar",
      "integ.hint.stripe": "sk_live_… o sk_test_… (Stripe Dashboard → Developers → API keys)",
      "integ.hint.resend": "re_… (resend.com/api-keys)",
      "integ.hint.daily": "dashboard.daily.co → Developers → API key",
      "integ.hint.meta_oauth": "developers.facebook.com/apps → App ID + App Secret",
      "integ.hint.linkedin_oauth": "linkedin.com/developers/apps → Client ID + Client Secret",
      "integ.hint.anthropic": "sk-ant-… (console.anthropic.com → API keys)",
      "integ.hint.gemini": "aistudio.google.com → Get API key",
      "fin.title": "Finanzas",
      "fin.subtitle": "MRR multidivisa, top consultas, series temporales.",
      "fin.daysSuffix": "d",
      "fin.mrrByCurrency": "MRR actual por moneda",
      "fin.totalRevenue": "Ingresos desde el lanzamiento",
      "fin.completedTx": "{n} transacciones completadas desde el lanzamiento",
      "fin.completedTxOne": "{n} transacción completada desde el lanzamiento",
      "fin.revenuePerDay": "Ingresos por día",
      "fin.noTxPeriod": "Ninguna transacción en este período.",
      "fin.signupsChurn": "Altas y bajas",
      "fin.churnDefinition": "Una baja es una consulta cuya suscripción se canceló, o que se eliminó cuando aún era cliente, contada el día en que se fue. Una suspensión no es una baja, y una consulta que vuelve más tarde sigue contada el día en que se fue.",
      "fin.noActivityPeriod": "Ninguna actividad en este período.",
      "fin.topTenants": "Top consultas por MRR (actual)",
      "fin.mrrHint": "Ingresos recurrentes de los profesionales atendidos hoy. No les afecta el período de abajo.",
      "fin.totalRevenueHint": "Acumulado histórico, neto de reembolsos. No le afecta el período de abajo.",
      "fin.periodTitle": "Últimos {n} días",
      "fin.periodRevenue": "Ingresos del período",
      "fin.periodTx": "{n} transacciones en el período",
      "fin.periodTxOne": "{n} transacción en el período",
      "fin.rangeLabel": "Período",
      "fin.revenueCurrency": "Moneda del gráfico",
      "fin.legendSignups": "Altas",
      "fin.legendChurn": "Bajas",
      "fin.noPayingTenant": "Ninguna consulta activa de pago.",
      "fin.topTenantsHint": "Clasificados por moneda. Los importes en monedas distintas nunca se comparan.",
      "fin.noTopTenants": "Aún no hay consultas de pago.",
      "fin.arr": "ARR:",
      "pset.lblStripe": "Stripe (pagos + suscripciones)",
      "pset.lblResend": "Resend (emails transaccionales)",
      "pset.lblAnthropic": "Claude (Anthropic): asistente IA y texto",
      "pset.lblGemini": "Gemini (Google): generación de imágenes IA",
      "pset.lblMetaOauth": "Meta OAuth (Facebook + Instagram)",
      "pset.lblLinkedinOauth": "LinkedIn OAuth",
      "pset.title": "Configuración de la plataforma",
      "pset.subtitle": "Integraciones activas y configuración global.",
      "pset.integrations": "Integraciones",
      "pset.configuredActive": "Configurado y activo.",
      "pset.demoActive": "Modo demo activo — sin transacciones reales.",
      "pset.notConfigured": "No configurado. Define {keys} en Sistema → Integraciones.",
      "pset.openIntegrations": "Abrir Integraciones",
      "pset.fromEmail": "Remitente: {email}",
      "pset.tenantMailDomain": "Dominio de correo de las consultas: {domain}",
      "pset.tenantMailDomainNone": "Sin dominio de envío para las consultas: una consulta sin dominio verificado propio no puede enviar correos hasta que se defina {keys}.",
      "pset.keyPrefix": "Clave: {prefix}",
      "pset.badgeOk": "ACTIVO",
      "pset.badgeDemo": "DEMO",
      "pset.badgeOff": "INACTIVO",
      "pset.systemInfo": "Plataforma — info del sistema",
      "pset.publicUrl": "URL pública",
      "pset.defaultTenantSystem": "Consulta por defecto (sistema)",
      "pset.saDomainsSystem": "Dominios super-admin (sistema)",
      "pset.serverManaged": "Estos valores vienen de la configuración del servidor. Solo cambian mediante la configuración de despliegue, seguida de un reinicio.",
      "pset.teamAccessNote": "El acceso de cada operador se gestiona desde Equipo.",
      "pset.saDomainsNone": "Ninguno. El acceso viene solo de los permisos de Equipo y de la lista de correos permitidos.",
      "pp.fillOne": "Rellena al menos un campo.",
      "pp.savedProvider": "{label} guardado",
      "pp.error": "Error",
      "pp.policyUpdated": "Política de pago actualizada",
      "pp.connValid": "{label}: conexión válida",
      "pp.connInvalid": "{label}: {error}",
      "pp.invalid": "inválida",
      "pp.testError": "Error de prueba",
      "pp.title": "Proveedores de pago",
      "pp.subtitle": "Configura Stripe y PayPal para la plataforma Solunary.",
      "pp.allowedMethods": "Métodos de pago permitidos",
      "pp.allowedDesc": "Bloquea globalmente un método de pago: los profesionales ya no podrán usarlo ni conectarlo.",
      "pp.methodStripe": "Stripe (suscripciones)",
      "pp.methodStripeConnect": "Stripe Connect (marketplace)",
      "pp.methodPaypal": "PayPal",
      "pp.blocked": "Bloqueado",
      "pp.allowed": "Permitido",
      "pp.getKeys": "→ Obtén tus claves",
      "pp.connValidShort": "Conexión válida",
      "pp.statusConfigured": "Configurado",
      "pp.statusEnabled": "Activado",
      "pp.statusInactive": "Inactivo",
      "pp.currentMasked": "(actual oculto — dejar vacío para mantener)",
      "pp.sandbox": "Sandbox",
      "pp.production": "Producción",
      "pp.enabled": "Activado",
      "pp.test": "Probar",
      "pp.save": "Guardar",
      "cat.skuUpdated": "SKU actualizado",
      "cat.error": "Error",
      "cat.boosterUpdated": "Booster actualizado",
      "cat.skuIdNameReq": "sku_id y nombre requeridos",
      "cat.skuCreated": "SKU creado",
      "cat.boosterIdNameReq": "booster_id y nombre requeridos",
      "cat.boosterCreated": "Booster creado",
      "cat.confirmDeleteSku": "¿Eliminar el SKU {id}?",
      "cat.skuDeleted": "SKU eliminado",
      "cat.confirmDeleteBooster": "¿Eliminar el booster {id}?",
      "cat.boosterDeleted": "Booster eliminado",
      "cat.title": "Catálogo de productos",
      "cat.subtitle": "SKU de pago único (instalación llave en mano, migración de datos) y Boosters recurrentes — crea, edita, elimina.",
      "cat.tabSkus": "SKU de pago único",
      "cat.tabBoosters": "Boosters recurrentes",
      "cat.newSku": "Nuevo SKU",
      "cat.phSkuId": "sku_id (ej: setup_quick)",
      "cat.phName": "Nombre",
      "cat.phTagline": "Eslogan (opcional)",
      "cat.createSku": "Crear el SKU",
      "cat.save": "Guardar",
      "cat.newBooster": "Nuevo Booster",
      "cat.phBoosterId": "booster_id (ej: academy_pro)",
      "cat.createBooster": "Crear el booster",
      "team.loadError": "No se pudo cargar",
      "team.error": "Error",
      "team.updated": "Actualización realizada",
      "team.confirmRemove": "¿Quitar a {email} del equipo?",
      "team.memberRemoved": "Miembro eliminado",
      "team.title": "Equipo Solunary",
      "team.subtitle": "Gestión de los empleados de la plataforma y sus permisos.",
      "team.invite": "Invitar a un miembro",
      "team.newMember": "Nuevo miembro",
      "team.phName": "Nombre completo",
      "team.add": "Añadir",
      "team.colMember": "Miembro",
      "team.colRole": "Rol",
      "team.colStatus": "Estado",
      "team.colPermissions": "Permisos",
      "team.colActions": "Acciones",
      "team.permissionsCount": "{n} permisos",
      "team.perm.tenants.read": "Ver consultas",
      "team.perm.tenants.write": "Editar consultas",
      "team.perm.tenants.delete": "Eliminar consultas",
      "team.perm.catalog.read": "Ver el catálogo",
      "team.perm.catalog.write": "Editar el catálogo",
      "team.perm.finance.read": "Ver finanzas",
      "team.perm.finance.write": "Editar finanzas",
      "team.perm.billing.rebate": "Conceder descuentos",
      "team.perm.billing.adjust": "Ajustar la facturación",
      "team.perm.billing.refund": "Emitir reembolsos",
      "team.perm.activity.read": "Ver la actividad",
      "team.perm.audit.read": "Ver el registro de auditoría",
      "team.perm.settings.read": "Ver la configuración",
      "team.perm.settings.write": "Editar la configuración",
      "team.perm.team.read": "Ver el equipo",
      "team.perm.team.write": "Gestionar el equipo",
      "team.perm.data.crm.read": "Ver clientes de HQ",
      "team.perm.data.crm.write": "Editar clientes de HQ",
      "team.perm.data.bookings.read": "Ver reservas",
      "team.perm.data.promos.read": "Ver promociones",
      "team.perm.data.giftcards.read": "Ver tarjetas regalo",
      "team.perm.data.insights.read": "Ver analíticas",
      "team.perm.data.insights.write": "Generar análisis con IA y usar el agente de IA",
      "team.perm.data.programs.read": "Ver programas",
      "team.perm.data.content.read": "Ver contenido",
      "team.perm.data.media.read": "Ver medios",
      "team.perm.data.branding.read": "Ver la marca",
      "team.perm.data.roadmap.read": "Ver la hoja de ruta",
      "team.itsYou": "(eres tú)",
      "team.empty": "Ningún miembro. Invita a tu primer colaborador.",
      "team.rolesPerms": "Roles y permisos",
      "tl.confirmDelete": "¿Eliminar la consulta {tid}? Sus suscripciones de Solunary (plan y complementos) se cancelarán de inmediato en Stripe: no se emitirá ninguna factura más. Las facturas ya impagas siguen adeudadas. Su dirección, y todas las que tuvo antes, no se podrán volver a usar nunca. Acción irreversible.",
      "tl.opOk": "Operación exitosa",
      "tl.error": "Error",
      "tl.title": "Consultas",
      "tl.countLine": "{n} consultas en la plataforma",
      "tl.searchPh": "Buscar...",
      "tl.colCabinet": "Consulta",
      "tl.colOwner": "Propietario",
      "tl.colPlan": "Plan",
      "tl.colStatus": "Estado",
      "tl.colActions": "Acciones",
      "tl.view360": "Vista 360° completa",
      "tl.viewSite": "Ver el sitio",
      "tl.manageAdmin": "Gestionar el admin de esta consulta",
      "tl.changePlan": "Cambiar el plan",
      "tl.suspend": "Suspender",
      "tl.activate": "Activar",
      "tl.delete": "Eliminar",
      "tl.changePlanFor": "Cambiar el plan — {name}",
      "tl.currentPlan": "Plan actual:",
      "tl.planChanged": "Plan cambiado: {from} → {to}",
      "tl.currentPlanBadge": "Plan actual",
      "tl.cancel": "Cancelar",
      "hc.title": "CRM de Solunary",
      "hc.subtitle": "Gestiona los profesionales, prospectos y su ciclo de vida.",
      "hc.syncTenants": "Sincronizar desde las consultas",
      "hc.new": "Nuevo",
      "hc.searchPh": "Buscar email, nombre...",
      "hc.colName": "Nombre",
      "hc.colEmail": "Email",
      "hc.colStage": "Etapa",
      "hc.colPlan": "Plan",
      "hc.colTenant": "Consulta",
      "hc.colNps": "NPS",
      "hc.empty": "Ningún cliente coincide.",
      "hc.updated": "Actualizado",
      "hc.error": "Error",
      "hc.confirmDelete": "¿Eliminar este cliente?",
      "hc.deleted": "Eliminado",
      "hc.stageInfos": "Etapa e info",
      "hc.phPhone": "Teléfono",
      "hc.phCompany": "Empresa",
      "hc.phNps": "NPS (0-10)",
      "hc.phNotes": "Notas",
      "hc.save": "Guardar",
      "hc.arNone": "Nada adeudado",
      "hc.arBalance": "Adeudado a Solunary",
      "hc.communications": "Comunicaciones",
      "hc.noComms": "Ninguna comunicación.",
      "hc.phSubject": "Asunto",
      "hc.phContent": "Contenido",
      "hc.linkedTenant": "Consulta vinculada",
      "hc.deleteClient": "Eliminar este cliente",
      "hc.created": "Cliente creado",
      "hc.newClient": "Nuevo cliente",
      "hc.phName": "Nombre",
      "hc.create": "Crear",
      "hc.stage.lead": "Prospecto",
      "hc.stage.trial": "Prueba",
      "hc.stage.active": "Activo",
      "hc.stage.at_risk": "En riesgo",
      "hc.stage.suspended": "Suspendido",
      "hc.stage.churned": "Perdido",
      "hc.noPermission": "No tienes permiso para modificar los clientes de HQ.",
      "hc.notFound": "Este cliente ya no existe.",
      "hc.emailExists": "Ya existe un cliente con este email.",
      "hc.openExisting": "Abrir el cliente existente",
      "hc.npsInvalid": "El NPS debe ser un número entero de 0 a 10.",
      "hc.tags": "Etiquetas",
      "hc.tagsPh": "Añadir una etiqueta (Intro o coma)",
      "hc.tagRemove": "Quitar la etiqueta {tag}",
      "hc.tagTooLong": "Una etiqueta tiene como máximo {max} caracteres.",
      "hc.tagTooMany": "Un cliente tiene como máximo {max} etiquetas.",
      "hc.tagControl": "Una etiqueta no puede contener caracteres de control.",
      "hc.practice": "Consulta",
      "hc.practiceStatus": "Estado",
      "hc.practiceSite": "Sitio web",
      "hc.deleteLinked": "Este cliente es propietario de una consulta. Gestiona o cierra la consulta en su lugar.",
      "hc.tenantStatus.pending": "Pendiente",
      "hc.tenantStatus.active": "Activo",
      "hc.tenantStatus.suspended": "Suspendido",
      "hc.tenantStatus.cancelled": "Cancelado",
      "hc.tenantStatus.expired": "Caducado",
      "hf.title": "Solunary Finance",
      "hf.subtitle": "P&L, cuentas por cobrar (AR), gastos internos, proyecciones.",
      "hf.tab.pl": "P&L",
      "hf.tab.ar": "Adeudado a Solunary",
      "hf.tab.expenses": "Gastos",
      "hf.tab.forecast": "Forecast",
      "hf.totalRevenue": "Ingreso total",
      "hf.totalExpenses": "Gastos total",
      "hf.net": "Neto",
      "hf.revVsExp": "Ingresos vs Gastos (mensual, {currency})",
      "hf.noHistory": "Ningún dato histórico.",
      "hf.legendRevenue": "Ingreso",
      "hf.legendExpenses": "Gastos",
      "hf.legendNet": "Neto",
      "hf.bucket.current": "Al día",
      "hf.daysOverdue": "{n} d",
      "hf.bucket.1_30": "1-30d",
      "hf.bucket.31_60": "31-60d",
      "hf.bucket.61_90": "61-90d",
      "hf.bucket.90_plus": "90d+",
      "hf.arByTenant": "Cuentas por cobrar por consulta",
      "hf.totalDue": "Total adeudado:",
      "hf.colTenant": "Consulta",
      "hf.colInvoices": "Facturas",
      "hf.colMaxDelay": "Atraso máx.",
      "hf.colAmount": "Importe",
      "hf.noOpenAr": "Ninguna consulta adeuda dinero a Solunary.",
      "hf.arExplainer": "Facturas de suscripción de Solunary impagas de las consultas, actualizadas desde Stripe. La antigüedad se cuenta desde el vencimiento de cada factura. Una factura cuya dirección nunca perteneció a una consulta conocida aquí figura como consulta desconocida.",
      "hf.arDeletedPractice": "{name} (consulta eliminada)",
      "hf.arUnknownPractice": "{id} (consulta desconocida)",
      "hf.arDeletedIdentity": "Dirección {address} · eliminada el {date}",
      "hf.arDeletedIdentityUndated": "Dirección {address}",
      "hf.expenses365": "Gastos 365d",
      "hf.newExpense": "Nuevo gasto",
      "hf.expenseSaved": "Gasto registrado",
      "hf.error": "Error",
      "hf.phAmount": "Importe",
      "hf.phVendor": "Proveedor",
      "hf.phDescription": "Descripción",
      "hf.saveExpense": "Guardar",
      "hf.confirmDeleteExpense": "¿Eliminar este gasto?",
      "hf.deleted": "Eliminado",
      "hf.byCategory": "Por categoría",
      "hf.noExpense": "Ningún gasto.",
      "hf.history": "Historial",
      "hf.months": "{n} meses",
      "hf.currency": "Moneda",
      "hf.baseCurrentMonth": "Base mes actual",
      "hf.avgMonthlyGrowth": "Crecimiento mensual prom.",
      "hf.projectionTitle": "Proyección {n} meses ({currency})",
      "hf.forecastExcluded": "Fuera de la proyección (otras monedas, últimos 4 meses): {amounts}.",
      "hf.notEnoughHistory": "No hay suficiente historial para proyectar.",
      "hsoc.title": "Solunary Social",
      "hsoc.subtitle": "Gestión de las cuentas @solunary y planificación de las publicaciones.",
      "hsoc.newPost": "Nuevo post",
      "hsoc.connectedAccounts": "Cuentas conectadas",
      "hsoc.connect": "Conectar",
      "hsoc.noAccounts": "Ninguna cuenta conectada. Conecta tu Facebook/Instagram/LinkedIn @solunary.",
      "hsoc.confirmDisconnect": "¿Desconectar esta cuenta?",
      "hsoc.disconnected": "Desconectado",
      "hsoc.publications": "Publicaciones",
      "hsoc.noPosts": "Ningún post.",
      "hsoc.demo": "demo",
      "hsoc.confirmDeletePost": "¿Eliminar este post?",
      "hsoc.connectAccount": "Conectar una cuenta",
      "hsoc.accountConnected": "Cuenta conectada",
      "hsoc.error": "Error",
      "hsoc.phHandle": "@handle",
      "hsoc.phPageId": "Page ID (opcional)",
      "hsoc.phAccessToken": "Access Token (opcional)",
      "hsoc.platforms": "Plataformas",
      "hsoc.connectFirst": "Conecta primero una cuenta.",
      "hsoc.choosePlatform": "Elige al menos una plataforma.",
      "hsoc.postScheduled": "Post programado",
      "hsoc.postPublished": "Post publicado (demo)",
      "hsoc.phBody": "¿Qué quieres compartir?",
      "hsoc.phMediaUrl": "URL de medio (opcional)",
      "hsoc.scheduleLabel": "Programar (dejar vacío para publicar ahora)",
      "hsoc.schedule": "Programar",
      "hsoc.publish": "Publicar",
      "hauto.title": "Automatizaciones de Solunary",
      "hauto.subtitle": "Reglas activadas por eventos de la plataforma.",
      "hauto.ruleCreated": "Regla creada",
      "hauto.error": "Error",
      "hauto.confirmDelete": "¿Eliminar?",
      "hauto.chooseTemplate": "Elige una plantilla para instalar:",
      "hauto.enterNumber": "Ingresa el número (1-{n}):",
      "hauto.templateInstalled": "Plantilla «{name}» instalada",
      "hauto.installTemplate": "Instalar plantilla",
      "hauto.visualEditor": "Editor visual",
      "hauto.newRule": "Nueva regla",
      "hauto.phRuleName": "Nombre de la regla",
      "hauto.actionsHint": "Acciones (haz clic para añadir o quitar)",
      "hauto.create": "Crear",
      "hauto.rulesTitle": "Reglas ({n})",
      "hauto.enableDisable": "Activar/Desactivar",
      "hauto.runs": "ejecuciones",
      "hauto.testRun": "Simulación",
      "hauto.editVisually": "Editar visualmente",
      "hauto.noRules": "Ninguna regla.",
      "hauto.recentRuns": "Ejecuciones recientes",
      "hauto.actions": "acciones",
      "hauto.noRuns": "Ningún run.",
      "hauto.dryRun.title": "Simulación: {rule}",
      "hauto.dryRun.hint": "Evalúa la regla y lista lo que haría cada acción. No se modifica ni se envía nada.",
      "hauto.dryRun.practice": "Consulta a simular (opcional)",
      "hauto.dryRun.noPractice": "Ninguna consulta",
      "hauto.dryRun.searchPractice": "Buscar consultas",
      "hauto.dryRun.run": "Ejecutar simulación",
      "hauto.dryRun.close": "Cerrar",
      "hauto.dryRun.badge": "Simulación",
      "hauto.dryRun.matched": "Las condiciones de la regla se cumplen.",
      "hauto.dryRun.notMatched": "Las condiciones de la regla no se cumplen: no se ejecutaría ninguna acción.",
      "hauto.dryRun.nothingChanged": "Solo simulación: no se modificó ningún dato.",
      "hauto.status.succeeded": "Correcto",
      "hauto.status.partial": "Parcial",
      "hauto.status.skipped": "Omitido",
      "hauto.status.failed": "Fallido",
      "hauto.status.running": "En curso",
      "hauto.outcome.applied": "Aplicada",
      "hauto.outcome.simulated": "Simulada",
      "hauto.outcome.skipped": "Omitida",
      "hauto.outcome.failed": "Fallida",
      "hauto.outcomeDry.applied": "Se aplicaría",
      "hauto.outcomeDry.simulated": "Se simularía",
      "hauto.outcomeDry.skipped": "Se omitiría",
      "hauto.outcomeDry.failed": "Fallaría",
      "hauto.legacy": "antiguo",
      "hauto.showActions": "Mostrar acciones",
      "hauto.hideActions": "Ocultar acciones",
      "hauto.noActionResults": "No se registró el detalle de las acciones.",
      "hauto.action.send_email": "Enviar correo",
      "hauto.action.create_task": "Crear tarea",
      "hauto.action.notify_slack": "Notificar a Slack",
      "hauto.action.tag_customer": "Etiquetar cliente",
      "hauto.action.update_lifecycle": "Cambiar etapa del cliente",
      "hauto.detail.tagged": "Etiqueta «{tag}» añadida.",
      "hauto.detail.already_tagged": "La etiqueta «{tag}» ya está presente.",
      "hauto.detail.invalid_tag": "La etiqueta de la regla no es válida.",
      "hauto.detail.stage_set": "Etapa cambiada de «{previous_stage}» a «{stage}».",
      "hauto.detail.already_in_stage": "El cliente ya está en la etapa «{stage}».",
      "hauto.detail.invalid_stage": "Etapa desconocida: {stage}.",
      "hauto.detail.no_customer": "No hay ninguna ficha de cliente que coincida.",
      "hauto.detail.task_created": "Tarea creada: {title}.",
      "hauto.detail.email_sent": "Correo enviado a {to}.",
      "hauto.detail.email_not_configured": "No hay clave de envío configurada: nada salió del sistema (destinatario: {to}).",
      "hauto.detail.no_recipient": "Sin destinatario.",
      "hauto.detail.email_failed": "Falló el envío del correo a {to}.",
      "hauto.detail.slack_not_configured": "Slack no está conectado: no se envió nada.",
      "hauto.detail.unknown_action": "Tipo de acción desconocido: {type}.",
      "hauto.detail.action_error": "La acción encontró un error.",
      "hauto.detail.customer_created": "Se creó la ficha de cliente.",
      "hauto.detail.customer_would_be_created": "Se crearía la ficha de cliente.",
      "vwe.newRule": "Nueva regla visual",
      "vwe.saved": "Workflow guardado",
      "vwe.error": "Error",
      "vwe.phRuleName": "Nombre de la regla",
      "vwe.save": "Guardar",
      "vwe.legendTrigger": "Disparador",
      "vwe.legendActions": "Acciones",
      "vwe.dragHint": "Arrastra y suelta para reorganizar · haz clic en «+» para añadir una acción",
      "t360.sec.crm": "Contactos CRM",
      "t360.sec.bookings": "Citas",
      "t360.sec.promos": "Promos",
      "t360.sec.giftcards": "Tarjetas regalo",
      "t360.sec.products": "Tienda",
      "t360.sec.programs": "Programas",
      "t360.sec.blog": "Artículos",
      "t360.sec.media": "Medios",
      "t360.sec.automation": "Automatizaciones",
      "t360.sec.social_posts": "Publicaciones sociales",
      "t360.sec.ai_sessions": "Sesiones IA",
      "t360.sec.insights": "Análisis IA",
      "t360.sec.invoices": "Facturas",
      "t360.sec.transactions": "Transacciones",
      "t360.error": "Error",
      "t360.back": "Volver a las consultas",
      "t360.openDashboard": "Abrir el panel de la consulta",
      "t360.financialActions": "Acciones financieras:",
      "t360.rebate": "Descuento",
      "t360.adjustPrice": "Ajustar precio",
      "t360.refund": "Reembolsar",
      "t360.plan": "Plan",
      "t360.revenue30d": "Ingresos 30d",
      "t360.subscription": "Suscripción",
      "t360.entitlements": "Funciones adquiridas",
      "t360.financialHistory": "Historial financiero",
      "t360.rebatesCredits": "Descuentos / créditos",
      "t360.by": "por",
      "t360.refundsTitle": "Reembolsos",
      "t360.reasonRequired": "La justificación es obligatoria (mín. 3 caracteres).",
      "t360.titleRebate": "Conceder un descuento",
      "t360.titleAdjust": "Ajustar el precio de la consulta",
      "t360.titleRefund": "Reembolsar una transacción",
      "t360.amount": "Importe",
      "t360.amountRefundHint": "(vacío = reembolso total)",
      "t360.justification": "Justificación (obligatoria, se registrará)",
      "t360.confirm": "Confirmar",
  },
};
